// Import React Libraries and Components
import React, { Component } from "react";
import SectionWithBorder from "../../../components/UIComponent/SectionBorder";
import BasicAppication from "../../../components/membership/slotsMembers/BasicApplication";
import OrganisationProfile from "../../../components/membership/slotsMembers/OrganisationProfile";
import SLOTSApplication from "../../../components/membership/slotsMembers/SLOTSApplication";
import {
  SLOTSMemberValidationRules,
  SLOTSAuthorisedRepresentativeValidationRules,
  SLOTSMemberBCAScopeValidationRules,
  SLOTSMemberRegistrationScopeValidationRules,
  SLOTSMemberBasicApplicationValidationRules,
  SLOTSMemberOrganisationProfileValidationRules,
  SLOTSApplicationValidationRules,
  ProjectTrackRecordValidationRules

} from "./SLOTSMemberValidationRules";
import {
  CommonValidationMessages,
  CommonSuccessMessages,
  SuccessMessage,
} from "../../../utils/Messages";
import {
  isValidForm,
  validate,
} from "../../../utils/validation/CommonValidator";
import { checkParameters } from "../../../utils/Encryption";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";

// Import API Services
import SlotMemberService from "../../../services/axiosServices/apiServices/SlotMemberService";
import SwalServices from "../../../services/swalServices/SwalServices";
import SendClarifications from "./SendClarifications";
import moment from "moment";
import { saveAs } from "file-saver";
import CommonServices from "../../../services/axiosServices/apiServices/CommonServices";
import { Navigate } from "react-router-dom";
import SendRejectionReason from "./SendRejectionReason";
import CheckboxInput from "../../../components/inputs/CheckboxInput";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import RenewalScopeHeadDetails from "../../../components/membership/slotsMembers/RenewalScopeHeadDetails";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";
export default class EditSLOTSMember extends Component {
  constructor(props) {
    super(props);
    this.slotMemberService = new SlotMemberService();
    this.commonServices = new CommonServices();
    this.swalServices = new SwalServices();
    this.state = {
      validState: {
        isValid: true,
        error: {},
      },
      isDisabledFlag: false,
      arcaFiles: [],
      wpOnlineRecordFiles: [],
      bankAccountStatementList: [],
      cPFcontributionFiles: [],
      copyOfCPFContributionsOfCompletedProjectsList: [],
      approvedTechnicalQualificationList: [],
      supportingDocFormAOngoingList: [],
      supportingDocFormAOnCompleteList: [],
      companyBankFiles: [],
      supportingDocFormAList: [],
      certificateAttendance21stMonth: [],
      CertificateAttendance9thMonth: [],
      auditReminder18thMonth: [],
      route: null,
      isLoadingRejectAplication: false,
      isLoadingExpireApplication: false,
      isWPRecordLoader: false,
      is6MonCPFLoader: false,
      isCPFConLoader: false,
      isApprovedBCALoader: false,
      isBankAccStatLoader: false,
      isOnGoingProLoader: false,
      isOnGoingProLoader2: false,
      isCompProLoader: false,
      isCompProLoader2: false,
      isDraftLoader: false,
      isSubmitLoader: false,
      isPaymentProofLoader: false,
      isACRACerLoader: false,
      isPaymentLinkLoader: false,
      isWorkshopProofLoader: false,
      isRepresentativeLoader: false,
      isFormALoader: false,
      isFormASupportingDocumentLoader: false,
      fileUploadCount: 0,
      cpfContributionLocalCount: 0,
      wPOnlineRecordCount: 0,
      copyofcpfContributionLocalCount: 0,
      approvedTechnicalQualificationCount: 0,
      companyBankAccStatementCount: 0,
      supportingDocOngoingFileUploadCount: 0,
      supportingDocCompleteFileUploadCount: 0,
      onGoingProjectFileUploadCount: 0,
      LetterofAwardorPurchaseCount: 0,
      finalInvoiceFileCount: 0,
      completedProjectFileUploadCount: 0,
      projectTrackOnGoingProjectList: [],
      letterofAwardorPurchaseOrderList: [],
      isWithNewSubscriptionPeriod: true,
      certificateofcompletionList: [],
      finalInvoiceFilePathList: [],
      fileDeletedFlag: false,
      isExpiredMember: false,
      isConfirmedCRS: false,
      isRegisteringasSlots: false,
      corporatebankRecordCount: 0,
      fileListCorporatebankRecordsList: [],
      certificateofcompletionCount: 0,

      // All dropdown list
      status: [],
      countryList: [],
      annualTurnoverList: [],
      staffEmployeeLocalList: [
        {
          value: 1,
          label: "Emp List 1",
        },
        {
          value: 2,
          label: "Emp List 2",
        },
        {
          value: 3,
          label: "Emp List 3",
        },
      ],
      updatedBy: 0,
      updatedAppId: 0,
      adminName: '',
      roleList: [],
      mainGroupList: [],
      workheadList: [],
      gradeList: [],
      mainGroupListPricing: [],
      auditCertificateDetailes: [],
      workheadListPricing: [],
      slotsMemberId: 0,
      foreignWorkPermitHolderList: [],
      RegisteredCompanyTypesList: [],
      SlotProjectTypeList: [],
      directors: [],
      shareholders: [],
      directorAndShareHolderList: [],

      renewalPriceCalculatorArray: [
        {
          value: 1,
          description: "Registration of Trade-head(s) under same category (max 2)",
          quantity: 0,
          Amount: 0
        },
        {
          value: 2,
          description:
            "Registration of additional Trade-head(s) under existing category",
          quantity: 0,
          Amount: 0
        },
        {
          value: 3,
          description: "Subtotal (before GST)",
          quantity: 0,
          Amount: 0
        }
      ],
      priceCalculatorArray: [
        {
          value: 1,
          description:
            "Registration of Trade-head(s) under same category (max 2)",
          quantity: 0,
          Amount: 0,
        },
        {
          value: 1,
          description:
            "Registration of additional Trade-head(s) under existing category",
          quantity: 0,
          Amount: 0,
        },
        {
          value: 3,
          description: "Subtotal (before GST)",
          quantity: "",
          Amount: 0,
        },
      ],
      priceCalculatorArrayTopUpAdditional: [
        {
          value: 1,
          description:
            "Registration of Trade-head(s) under same category (max 2)",
          quantity: 0,
          Amount: 0,
        },
        {
          value: 1,
          description:
            "Registration of additional Trade-head(s) under existing category",
          quantity: 0,
          Amount: 0,
        },
        {
          value: 3,
          description: "Subtotal (before GST)",
          quantity: "",
          Amount: 0,
        },
      ],
      // SLOTS Application Details object
      renewalDataLength: 0,



      SLOTSApplicationDetails: {

        projectTractRecordFile: "",
        fileList10: [],

        IsMigratedData: false,
        CertificateMembershipNo: "",
        slotsMemberId: 0,
        isRenewal: 0,
        isRenewal: false,
        companyName: "",
        chineseCompanyName: "",
        uenNumber: "",
        dateOfIncorporation: "",
        mailingAddress1: "",
        mailingAddress2: "",
        mailingAddress3: "",
        countryId: "",
        postalCode: "",
        businessTelNo: "",
        businessEmail: "",
        hashedPassword: "",
        passwordSalt: "",
        buildingAddress: "",
        annualTurnOverId: 0,
        companyDescription: "",
        isCompanySafetyRelatedIssues: "",
        specifyReason: "",
        moreInformation: "",
        numberOfStaffEmployedLocalId: 0,
        foreignWorkPermitHolder: "",
        foreignWorkPermitHolderId: 0,
        foreignWorkPermitHolderLabel: "",
        uploadACRACertificate: "",
        uploadWPOnlineRecord: "",
        latest6monthsCPFContribution: "",
        copyOfCPFContributionsOfCompletedProjects: "",
        approvedTechnicalQualification: "",
        headOfCompanyFirstName: "",
        paidUpCapital: "",
        headOfCompanyLastName: "",
        jobTitle: "",
        directOfficeNumber: "",
        mobileNumber: "",
        email: "",
        companyBankStatementsOf6Month: "",
        isCompanyActivities: true,
        projectTrackRecordsOfOnGoingProject: "",
        projectTrackRecordsOfCompletedProject: "",
        membershipTypeId: "",
        uploadPaymentProof: "",
        isActive: "",
        authorisedRepresentativeSummaryList: [],
        registeredBCAScopeList: [],
        slotsRegistrationHeadScope: [],
        slotsRegistrationHeadScopeTopUp: [],
        slotsRegistrationHeadScopeTopUpAdditional: [],
        renewalSLOTSRegistrationHeadScope: [],
        auditdetailes: [],
        priceCalculator: [],
        renewalPriceCalculator: [],
        statusId: 0,
        workshopProofPath: "",
        supportingDocFormAOngoing: "",
        supportingDocFormAOnComplete: "",
        isSgMAworkshopCertificate: false,
        isoOrGreenPolicy: "",
        iaoOrbizSAFEStar: "",
        appointmentletterforSGSecure: "",
        fileListOfWPRecord: [],
        fileList2: [],
        fileListOfcopyofcpfContribution: [],
        fileListOfApprovedTechnicalQualification: [],
        bankAccountStatementList: [],
        formAOnGoingList: [],
        formACompletedList: [],
        formA: "",
        supportingDocFormA: "",
        supportingDocFormAList: [],
        auditCertificateDetailes: [],
        certificateofAttendance: "",
        isPaymentLinkSentForRenewal: false,
        isForceRenewal: false,
        isExpiredMember: false,
        CreditNoteStatusId: 0,
        formAOnGoingProjectList: [],

        projectTrackRecordsOfCompletedList: [],
        formAList: [],
        filetypeName: "",
        uploadDate: "",
        comments: "",
        schedulerName: "",
        createdAt: "",
        comments: "",
        auditReauditCertificateDetailesminder18thMonth: [],
        IsRegisteringasSlots: false,
        IsConfirmedCRS: false,
        companyTypeId: 0,
        projectTypeId: 0,
        fileListCorporatebankRecords: [],
        directorAndShareHolderList: [],
        directorList: [],
        shareHolderList: [],
        projectTrackRecordsDetailsList: [],
        fileListCertificateOfCompletion: [],
        uploadCorporatebankRecords: "",
        //specifyOtherCompanyType: ""
      },
      completedProjectTrackRecordsDetailsList: [],
      ongoingProjectTrackRecordsDetailsList: [],
      projectTrackRecordsDetailsList: [],
      IsCompleted: false,
      IsOngoing: false,
      isForceRenewalLoader: false,
      supportingDocFormACount: 0,
      formACount: 0,
      isBasicApplicationLoading: false,
      isOrganisationProfileLoading: false,
      // Roles Details Object
      roleDetails: {
        authorisedRepresentativeId: 0,
        roleId: 0,
        roles: "",
        firstName: "",
        lastName: "",
        jobTitle: "",
        directOfficeNumber: "",
        mobileNumber: "",
        emailAddress: "",
        isNewsletter: false,
        isTelegram: false,
        isePortal: false,
        sLOTSMemberId: 0,


      },
      projectTrackRecordsDetails: {
        projectTrackRecordID: 0,
        slotsMemberId: 0,
        contractNo: "",
        projectTitle: "",
        projectType: "",
        agency: "",
        projectLocation: "",
        dateOfCommencement: "",
        dateofCompletion: "",
        awardValue: "",
        mainContractorName: "",
        mainContractorTelephoneNo: "",
        mainContractorEmail: "",
        contactPersonName: "",
        hasLetterOfAwardOrPO: "",
        hasInvoicesWithPaymentProof: "",
        hasCertificateOfCompletion: "",
        isCompleted: false,
        isOngoing: false,
        letterofAwardorPurchaseOrderDocs: "",
        certificateOfCompletionPath: "",
        finalInvoiceFilePath: "",
        letterofAwardorPurchaseOrderList: [],
        certificateofcompletionList: [],
        finalInvoiceFilePathList: [],
        projectType: 0,
      },
      // Buildings and Scope Object
      selectedBuildingConScope: {
        scopeId: 0,
        mainGroupId: 0,
        workheadId: 0,
        gradeId: 0,
        mainGroupName: "",
        workheadName: "",
        gradeName: "",
      },
      // auditCertificateDetailes: {
      //   fileType: "",
      //   createdAt: "",
      //   comments: "",

      // },

      // SLOTS Registration Object
      selectedSLOTSRegistrationScope: {
        scopeId: 0,
        selectedMainGroupId: 0,
        selectedWorkheadId: 0,
        mainGroupName: "",
        workheadName: "",
        isTopup: false,
      },
      // slots member pricing
      slotsMemberPricingDetail: {
        membershipSLOTSPricingId: 0,
        slotsAdminFee: 0,
        slotsAnnual1To2TradeSameCategoryFee: 0,
        slotsAnnualTradeExistingCategoryFee: 0,
        slotsAnnual1To2TradeDifferentCategoryFee: 0,
      },

      // Sefty validation Rules
      specifyReason: [
        {
          type: "require",
          message: CommonValidationMessages.FieldRequired.replace(
            "{0}",
            "specify reason"
          ),
        },
      ],
      moreInformation: [
        {
          type: "require",
          message: CommonValidationMessages.FieldRequired.replace(
            "{0}",
            "more information"
          ),
        },
      ],
      uploadWPOnlineRecordValRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "document"
          ),
        },
      ],
      // Valid State Object
      validStateSLOTSMember: {
        isValid: true,
        error: {},
      },
      // Valid State Role Object
      validStateSLOTSMemberRole: {
        isValid: true,
        error: {},
      },
      // Valid State BCA Scope Object
      validStateBCAScope: {
        isValid: true,
        error: {},
      },
      // Valid State Registration Scope Object
      validStateregistrationScope: {
        isValid: true,
        error: {},
      },
      validStateProjectTrackRecord: {
        isValid: true,
        error: {},
      },
      paidUpCapitalValidationRule: [
        {
          type: "require",
          message: CommonValidationMessages.FieldRequired.replace("{0}", "paid-Up Capital"),
        },
        {
          type: "isMinimumAmount",
          message: "Amount must be at least ₹50,000"
        }
      ],

      // validStateBasicApplication: {
      //   isValid: true,
      //   error: {},
      // },

      validStateOrganisationProfile: {
        isValid: true,
        error: {},
      },
      setSendClarifications: false,
      clarification: "",
      setRejectionReason: false,
      sendRejectionReason: "",
      // sendRejectionReason: {},
      IsProbationaryAtStart: null,
      isLoading: false
    };

  }



  componentDidMount = () => {
    const audit = getAuditContext();

    let params = new URLSearchParams(window.location.search);

    let checkRead = window.location.search;
    let getRead = checkRead.split("=");
    let checkFinal = getRead[2];
    if (checkFinal === "ReadOnly") {
      this.setState({ isDisabledFlag: true });
    }

    let slotsId = params.get("");
    if (slotsId && (slotsId = checkParameters(slotsId, "Number"))) {
      if (slotsId != null && slotsId > 0) {
        this.setState({ slotsMemberId: slotsId });

      }
    }

    this.getAllDropDownsForSLOTSMember();
    this.getSLOTSMemberDetailByMemberId(slotsId);
    this.GetAllProjectTrackRecordsById(slotsId);
    this.getMembershipPricingWithGst();
    this.getUploadSLOTSBatchjobDetailes(slotsId);
    this.pricingCalculation();
    this.GetRenewalSLOTsRegistrationHeadByMemberId(slotsId)
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });


  };

  GetRenewalSLOTsRegistrationHeadByMemberId = (id) => {
    this.slotMemberService.GetRenewalSLOTsRegistrationHeadByMemberId(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {

        let res = this.state.SLOTSApplicationDetails;
        res.renewalPriceCalculator = (response.responseItem.responseContent || []).map(item => ({
          Amount: item.amount,
          description: item.description,
          quantity: item.quantity
        }));
        res.renewalSLOTSRegistrationHeadScope =
          response.responseItem.responseContent[0].renewalSLOTSRegistrationHeadScope;
        if (response.responseItem.responseContent.length > 0) {
          res.isRenewal = true;
        }
        this.setState({ SLOTSApplicationDetails: res });
        this.calculateRenewalPrice()
      }
    })
  }

  calculateRenewalPrice() {

    const list =
      this.state.SLOTSApplicationDetails.renewalSLOTSRegistrationHeadScope || [];

    const distinctMainGroupIds = [
      ...new Set(list.map(item => item.mainGroupId))
    ];
    const distinctMainGroupIdsCount = distinctMainGroupIds.length;

    let additionalExtraWorkheadCount = 0;

    distinctMainGroupIds.forEach(mainGroupId => {
      // count how many times this mainGroupId occurs
      const count = list.filter(item => item.mainGroupId === mainGroupId).length;

      // only count beyond 2
      if (count > 2) {
        additionalExtraWorkheadCount += (count - 2);
      }
    });

    let slotsPricing = this.state.slotsMemberPricingDetail;

    const BASE_PRICE = slotsPricing.slotsAnnual1To2TradeSameCategoryFee;
    const EXTRA_PRICE = slotsPricing.slotsAnnualTradeExistingCategoryFee;

    const baseAmount = distinctMainGroupIdsCount * BASE_PRICE;
    const additionalAmount = additionalExtraWorkheadCount * EXTRA_PRICE;
    let renewalPriceCalculator = [];
    renewalPriceCalculator = [
      {
        value: 1,
        description: "Registration of Trade-head(s) under same category (max 2)",
        quantity: distinctMainGroupIdsCount,
        Amount: baseAmount
      },
      {
        value: 2,
        description:
          "Registration of additional Trade-head(s) under existing category",
        quantity: additionalExtraWorkheadCount,
        Amount: additionalAmount
      },
      {
        value: 3,
        description: "Subtotal (before GST)",
        quantity: distinctMainGroupIdsCount + additionalExtraWorkheadCount,
        Amount: baseAmount + additionalAmount
      }
    ];
    this.setState({ renewalPriceCalculatorArray: renewalPriceCalculator });

    return renewalPriceCalculator;
  }




  AddSLOTSRenewalRegistrationHeadScope = () => {
    const audit = getAuditContext();

    let selectedScope = this.state.selectedSLOTSRegistrationScope;

    // Map selectedScope to the correct structure
    let normalizedScope = {
      scopeId: selectedScope.scopeId || 0, // keep existing scopeId or default to 0
      mainGroupId: selectedScope.selectedMainGroupId || selectedScope.mainGroupId,
      workheadId: selectedScope.selectedWorkheadId || selectedScope.workheadId,
      mainGroupName: selectedScope.mainGroupName,
      workheadName: selectedScope.workheadName,
      isTopup: selectedScope.isTopup || false
    };

    const isExist = this.state.SLOTSApplicationDetails.renewalSLOTSRegistrationHeadScope.some(
      item =>
        item.mainGroupId === normalizedScope.mainGroupId &&
        item.workheadId === normalizedScope.workheadId
    );
    if (isExist == true) {
      this.swalServices.Error("You cannot duplicate ");
      this.resetHandler("Reset_SLOTS_Registration_Section");
      return;
    }

    this.state.SLOTSApplicationDetails.renewalSLOTSRegistrationHeadScope.push(normalizedScope);

    let calculatedData = this.calculateRenewalPrice();

    let request = {};
    request.sLOTSMemberId = this.state.slotsMemberId;
    request.mainGroupId = this.state.selectedSLOTSRegistrationScope.selectedMainGroupId;
    request.sameCategoryAmount = calculatedData[0].Amount;
    request.sameCategoryQuantity = calculatedData[0].quantity;

    request.workheadId = this.state.selectedSLOTSRegistrationScope.selectedWorkheadId
    request.existingCategoryAmount = calculatedData[1].Amount;
    request.existingCategoryQuantity = calculatedData[1].quantity;

    request.subtotalAmount = calculatedData[2].Amount;
    request.subtotalQuantity = calculatedData[2].quantity;

    request.isRenewal = true;
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;


    this.slotMemberService
      .AddSLOTSRegistrationHeadScopeTopUp(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.resetHandler("Reset_SLOTS_Registration_Section");
          this.GetRenewalSLOTsRegistrationHeadByMemberId(request.sLOTSMemberId);

        }
      })

  }


  // Get All Dropdowns For SLOTS Member Method
  getAllDropDownsForSLOTSMember = () => {
    this.slotMemberService.getAllDropDownsForSLOTSMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        var mainGroupList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "ScopeMainGroup"
        );
        mainGroupList.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        mainGroupList = mainGroupList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ mainGroupListPricing: mainGroupList });

        var mainGroupListBCA = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "ScopeMainGroupBCA"
        );
        mainGroupListBCA.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        mainGroupListBCA = mainGroupListBCA.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ mainGroupList: mainGroupListBCA });

        var country = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "Country"
        );
        country.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        country = country.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ countryList: country });

        var annualTurnover = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "MembershipRevenue"

        );
        annualTurnover.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        annualTurnover = annualTurnover.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ annualTurnoverList: annualTurnover });

        var empStaffLocal = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "NumberOfStaffEmployedLocal"
        );
        empStaffLocal.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        empStaffLocal = empStaffLocal.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ staffEmployeeLocalList: empStaffLocal });

        var orgRole = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "OrganisationRole"
        );
        orgRole.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        orgRole = orgRole.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ roleList: orgRole });

        var ForeignWorkPermitHolder =
          response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "ForeignWorkPermitholder"
          );
        ForeignWorkPermitHolder.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        ForeignWorkPermitHolder = ForeignWorkPermitHolder.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ foreignWorkPermitHolderList: ForeignWorkPermitHolder });

        var RegisteredCompanyType =
          response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "RegisteredCompanyType"
          );
        RegisteredCompanyType.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        RegisteredCompanyType = RegisteredCompanyType.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ RegisteredCompanyTypesList: RegisteredCompanyType });


        var SlotProjectType =
          response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "SlotProjectType"
          );
        SlotProjectType.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        SlotProjectType = SlotProjectType.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ SlotProjectTypeList: SlotProjectType });

      }
    });
  };


  // getUploadSLOTSBatchjobDetailes = (id) => {

  //   this.slotMemberService.getUploadSLOTSBatchjobDetailes(id).then((response) => {

  //     if (response.statusCode === 200 && response.responseItem != null) {
  //       var newList = response.responseItem.responseContent;

  //       this.setState({ auditCertificateDetailes: newList });
  //     } else {
  //       this.swalServices.Error(response.message);
  //     }
  //   });
  // };


  getUploadSLOTSBatchjobDetailes = (id) => {

    this.slotMemberService.getUploadSLOTSBatchjobDetailes(id).then((response) => {

      if (response.statusCode === 200 && response.responseItem != null) {
        var newList = response.responseItem.responseContent;
        // const newList = response.responseItem.responseContent;

        this.setState({ auditCertificateDetailes: newList });

        // Audit Reminder (18th Month)
        let ListofAuditReminder18thMonth = newList.filter(item => item.fileType === 'Audit Reminder (18th Month)');
        ListofAuditReminder18thMonth = ListofAuditReminder18thMonth[0]?.uploadedFilename
          ?.split(',')
          .map(p => ({ path: p.trim() })) || [];

        // Certificate Attendance (9th Month)
        let ListofCertificateAttendace9Month = newList.filter(item => item.fileType === 'Certificate Attendance (9th Month)');
        ListofCertificateAttendace9Month = ListofCertificateAttendace9Month[0]?.uploadedFilename
          ?.split(',')
          .map(p => ({ path: p.trim() })) || [];

        // Certificate Attendance (21st Month)
        let ListofCertificateAttendace21Month = newList.filter(item => item.fileType === 'Certificate Attendance (21st Month)');
        ListofCertificateAttendace21Month = ListofCertificateAttendace21Month[0]?.uploadedFilename
          ?.split(',')
          .map(p => ({ path: p.trim() })) || [];

        // Set all states in one go
        this.setState({
          auditReminder18thMonth: ListofAuditReminder18thMonth,
          CertificateAttendance9thMonth: ListofCertificateAttendace9Month,
          certificateAttendance21stMonth: ListofCertificateAttendace21Month
        });

      } else {
        this.swalServices.Error(response.message);
      }
    });
  };
  // Get SOLTS Member Detail By Id
  getSLOTSMemberDetailByMemberId = (id) => {

    this.setState({ isBasicApplicationLoading: true });
    this.setState({ isOrganisationProfileLoading: true });
    // if (this.state.slotsMemberId > 0 && this.state.slotsMemberId != null) {
    // let request = new Object();
    // request.sLOTSMemberId = 1
    this.slotMemberService
      .getSLOTSMemberDetailByMemberId(id)
      .then((response) => {

        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent != null) {

            let res = { ...this.state.SLOTSApplicationDetails };
            let isRegisteringasSlots = { ...this.state.isRegisteringasSlots };
            let isConfirmedCRS = { ...this.state.isConfirmedCRS };
            isConfirmedCRS = response.responseItem.responseContent.isConfirmedCRS;
            isRegisteringasSlots = response.responseItem.responseContent.isRegisteringasSlots;

            // let arca = response.responseItem.responseContent.uploadACRACertificate
            //     ? response.responseItem.responseContent.uploadACRACertificate.split(',') : null;
            // if (arca) {
            //     arca = arca.map((p) => ({
            //         path: p,
            //     }));
            // }+
            let IsWithNewSubscriptionPeriod = response.responseItem.responseContent.isWithNewSubscriptionPeriod
            let DirectorandShareholderList_ = response.responseItem.responseContent.directorAndShareHolderList;

            // Get list of members who are directors
            // Get list of members who are directors
            let directorList_ = DirectorandShareholderList_
              .filter(m => m.isDirector === true)
              .map(({ nriC_FIN_Passport, dateofAppoitment, ...rest }) => ({
                ...rest,
                nRIC_FIN_Passport: nriC_FIN_Passport,
                dateofAppoitment: dateofAppoitment
              }));

            // Get list of members who are shareholders
            let shareholderList_ = DirectorandShareholderList_
              .filter(m => m.isShareHolder === true)
              .map(({ nriC_FIN_Passport, percentageOfshare, ...rest }) => ({
                ...rest,
                nRIC_FIN_Passport: nriC_FIN_Passport,
                percentageOfshare: percentageOfshare
              }));
            let wpOnlineRecord = response.responseItem.responseContent
              .uploadWPOnlineRecord
              ? response.responseItem.responseContent.uploadWPOnlineRecord.split(
                ","
              )
              : null;
            if (wpOnlineRecord) {
              wpOnlineRecord = wpOnlineRecord.map((p) => ({
                path: p,
              }));
            }

            let CPFcontribution = response.responseItem.responseContent
              .latest6monthsCPFContribution
              ? response.responseItem.responseContent.latest6monthsCPFContribution.split(
                ","
              )
              : null;
            if (CPFcontribution) {
              CPFcontribution = CPFcontribution.map((p) => ({
                path: p,
              }));
            }

            let CopyOfCPFContributionsOfCompletedProjects = response
              .responseItem.responseContent
              .copyOfCPFContributionsOfCompletedProjects
              ? response.responseItem.responseContent.copyOfCPFContributionsOfCompletedProjects.split(
                ","
              )
              : null;
            if (CopyOfCPFContributionsOfCompletedProjects) {
              CopyOfCPFContributionsOfCompletedProjects =
                CopyOfCPFContributionsOfCompletedProjects.map((p) => ({
                  path: p,
                }));
            }

            let companyBankStatements = response.responseItem.responseContent
              .companyBankStatementsOf6Month
              ? response.responseItem.responseContent.companyBankStatementsOf6Month.split(
                ","
              )
              : null;
            if (companyBankStatements) {
              companyBankStatements = companyBankStatements.map((p) => ({
                path: p,
              }));
            }

            let approvedTechnicalQualification = response.responseItem
              .responseContent.approvedTechnicalQualification
              ? response.responseItem.responseContent.approvedTechnicalQualification.split(
                ","
              )
              : null;
            if (approvedTechnicalQualification) {
              approvedTechnicalQualification =
                approvedTechnicalQualification.map((p) => ({
                  path: p,
                }));
            }

            let uploadCorporatebankRecords = response.responseItem
              .responseContent.uploadCorporatebankRecords
              ? response.responseItem.responseContent.uploadCorporatebankRecords.split(
                ","
              )
              : null;
            if (uploadCorporatebankRecords) {
              uploadCorporatebankRecords =
                uploadCorporatebankRecords.map((p) => ({
                  path: p,
                }));
            }
            let supportingDocFormAOngoingdocs = response.responseItem
              .responseContent.supportingDocFormAOngoing
              ? response.responseItem.responseContent.supportingDocFormAOngoing.split(
                ","
              )
              : null;
            if (supportingDocFormAOngoingdocs) {
              supportingDocFormAOngoingdocs = supportingDocFormAOngoingdocs.map(
                (p) => ({
                  path: p,
                })
              );
            }
            let projectTrackOnGoingProjectDocs = response.responseItem
              .responseContent.projectTrackRecordsOfOnGoingProject
              ? response.responseItem.responseContent.projectTrackRecordsOfOnGoingProject.split(
                ","
              )
              : null;
            if (projectTrackOnGoingProjectDocs) {
              projectTrackOnGoingProjectDocs = projectTrackOnGoingProjectDocs.map(
                (p) => ({
                  path: p,
                })
              );
            }
            let projectTrackRecordsOfCompletedDocs = response.responseItem
              .responseContent.projectTrackRecordsOfCompletedProject
              ? response.responseItem.responseContent.projectTrackRecordsOfCompletedProject.split(
                ","
              )
              : null;
            if (projectTrackRecordsOfCompletedDocs) {
              projectTrackRecordsOfCompletedDocs = projectTrackRecordsOfCompletedDocs.map(
                (p) => ({
                  path: p,
                })
              );
            }

            let supportingDocFormAOnCompletedocs = response.responseItem
              .responseContent.supportingDocFormAOnComplete
              ? response.responseItem.responseContent.supportingDocFormAOnComplete.split(
                ","
              )
              : null;
            if (supportingDocFormAOnCompletedocs) {
              supportingDocFormAOnCompletedocs =
                supportingDocFormAOnCompletedocs.map((p) => ({
                  path: p,
                }));
            }

            let supportingDocFormAs = response.responseItem
              .responseContent.supportingDocFormA
              ? response.responseItem.responseContent.supportingDocFormA.split(
                ","
              )
              : null;
            if (supportingDocFormAs) {
              supportingDocFormAs = supportingDocFormAs.map(
                (p) => ({
                  path: p,
                })
              );
            }
            let formAListDocs = response.responseItem
              .responseContent.formA
              ? response.responseItem.responseContent.formA.split(
                ","
              )
              : null;
            if (formAListDocs) {
              formAListDocs = formAListDocs.map(
                (p) => ({
                  path: p,
                })
              );
            }
            this.setState({
              wpOnlineRecordFiles: wpOnlineRecord,

              cPFcontributionFiles: CPFcontribution,
              copyOfCPFContributionsOfCompletedProjectsList:
                CopyOfCPFContributionsOfCompletedProjects,
              companyBankFiles: companyBankStatements,
              approvedTechnicalQualificationList: approvedTechnicalQualification,
              bankAccountStatementList: uploadCorporatebankRecords,
              supportingDocFormAOngoingList: supportingDocFormAOngoingdocs,
              supportingDocFormAOnCompleteList: supportingDocFormAOnCompletedocs,
              supportingDocFormAList: supportingDocFormAs,
              projectTrackOnGoingProjectList: projectTrackOnGoingProjectDocs,
              projectTrackRecordsOfCompletedList: projectTrackRecordsOfCompletedDocs,
              shareholders: shareholderList_, directors: directorList_,
              formAList: formAListDocs,
              isWithNewSubscriptionPeriod: IsWithNewSubscriptionPeriod

            });


            // SLOTS Basic Inforamtion
            res.slotsMemberId =
              response.responseItem.responseContent.slotsMemberId;
            res.CreditNoteStatusId =
              response.responseItem.responseContent.creditNoteStatusId;
            res.companyName = response.responseItem.responseContent.companyName;
            res.chineseCompanyName =
              response.responseItem.responseContent.chineseCompanyName;
            res.uenNumber = response.responseItem.responseContent.uenNumber;
            res.dateOfIncorporation =
              response.responseItem.responseContent.dateOfIncorporation;
            res.mailingAddress1 =
              response.responseItem.responseContent.mailingAddress1;
            res.buildingAddress =
              response.responseItem.responseContent.buildingAddress;
            res.mailingAddress2 =
              response.responseItem.responseContent.mailingAddress2;
            res.mailingAddress3 =
              response.responseItem.responseContent.mailingAddress3;
            res.countryId = response.responseItem.responseContent.countryId;
            res.postalCode = response.responseItem.responseContent.postalCode;
            res.businessTelNo =
              response.responseItem.responseContent.businessTelNo;
            res.businessEmail =
              response.responseItem.responseContent.businessEmail;
            res.appointmentletterforSGSecure =
              response.responseItem.responseContent.appointmentletterforSGSecure;
            res.isoOrGreenPolicy =
              response.responseItem.responseContent.isoOrGreenPolicy;
            res.iaoOrbizSAFEStar =
              response.responseItem.responseContent.iaoOrbizSAFEStar;
            res.isSgMAworkshopCertificate =
              response.responseItem.responseContent.isSgMAworkshopCertificate;
            // SLOTS Organisation Profile
            res.annualTurnOverId =
              response.responseItem.responseContent.annualTurnOverId;
            res.companyDescription =
              response.responseItem.responseContent.companyDescription;
            res.isCompanySafetyRelatedIssues =
              response.responseItem.responseContent.isCompanySafetyRelatedIssues;
            res.specifyReason =
              response.responseItem.responseContent.specifyReason;
            res.moreInformation =
              response.responseItem.responseContent.moreInformation;
            res.numberOfStaffEmployedLocalId =
              response.responseItem.responseContent.numberOfStaffEmployedLocalId;
            res.foreignWorkPermitHolderId =
              response.responseItem.responseContent.foreignWorkPermitHolderId;
            res.companyTypeId =
              response.responseItem.responseContent.companyTypeId;
            res.projectTypeId =
              response.responseItem.responseContent.projectTypeId;

            res.uploadACRACertificate =
              response.responseItem.responseContent.uploadACRACertificate;
            res.fileListCorporatebankRecords =
              response.responseItem.responseContent.fileListCorporatebankRecords;

            res.uploadWPOnlineRecord =
              response.responseItem.responseContent.uploadWPOnlineRecord;
            res.latest6monthsCPFContribution =
              response.responseItem.responseContent.latest6monthsCPFContribution;
            res.copyOfCPFContributionsOfCompletedProjects =
              response.responseItem.responseContent.copyOfCPFContributionsOfCompletedProjects;
            res.approvedTechnicalQualification =
              response.responseItem.responseContent.approvedTechnicalQualification;
            res.headOfCompanyFirstName =
              response.responseItem.responseContent.headOfCompanyFirstName;
            res.paidUpCapital =
              response.responseItem.responseContent.paidUpCapital;
            res.uploadCorporatebankRecords =
              response.responseItem.responseContent.uploadCorporatebankRecords;
            res.headOfCompanyLastName =
              response.responseItem.responseContent.headOfCompanyLastName;
            res.jobTitle = response.responseItem.responseContent.jobTitle;
            res.directOfficeNumber =
              response.responseItem.responseContent.directOfficeNumber;
            res.mobileNumber =
              response.responseItem.responseContent.mobileNumber;
            res.email = response.responseItem.responseContent.email;
            res.authorisedRepresentativeSummaryList =
              response.responseItem.responseContent.authorisedRepresentativeSummaryList;


            res.directorAndShareHolderList = response.responseItem.responseContent.directorAndShareHolderList;
            res.directorList = res.directorAndShareHolderList.filter(item => item.isDirector);
            res.shareHolderList = res.directorAndShareHolderList.filter(item => item.isShareHolder);
            //res.specifyOtherCompanyType = response.responseItem.responseContent.specifyOtherCompanyType;
            // SLOTS Application
            res.companyBankStatementsOf6Month =
              response.responseItem.responseContent.companyBankStatementsOf6Month;
            res.isCompanyActivities =
              response.responseItem.responseContent.isCompanyActivities;
            res.projectTrackRecordsOfOnGoingProject =
              response.responseItem.responseContent.projectTrackRecordsOfOnGoingProject;
            res.projectTrackRecordsOfCompletedProject =
              response.responseItem.responseContent.projectTrackRecordsOfCompletedProject;
            res.membershipTypeId =
              response.responseItem.responseContent.membershipTypeId;

            res.IsMigratedData =
              response.responseItem.responseContent.isMigratedData;

            res.CertificateMembershipNo =
              response.responseItem.responseContent.certificateMembershipNo;

            res.uploadPaymentProof =
              response.responseItem.responseContent.uploadPaymentProof;
            res.isActive = response.responseItem.responseContent.isActive;
            res.registeredBCAScopeList =
              response.responseItem.responseContent.registeredBCAScopeList;
            res.formA =
              response.responseItem.responseContent.formA;
            res.certificateofAttendance =
              response.responseItem.responseContent.certificateofAttendance;
            //res.slotsRegistrationHeadScope = response.responseItem.responseContent.slotsRegistrationHeadScope;
            let array =
              response.responseItem.responseContent.slotsRegistrationHeadScope;
            array.map((x) => {
              x.isTopup = false;
              return x;
            });

            res.slotsRegistrationHeadScope = array;

            console.log("no top up", res.slotsRegistrationHeadScope)
            let array2 =
              response.responseItem.responseContent
                .slotsRegistrationHeadScopeTopUp;
            array2.map((x) => {
              x.isTopup = true;
              x.selectedMainGroupId = x.mainGroupId;
              x.selectedWorkheadId = x.mainWorkHeadId;
              return x;
            });

            res.slotsRegistrationHeadScopeTopUp = array2;

            console.log("topup", res.slotsRegistrationHeadScopeTopUp)
            let array3 =
              response.responseItem.responseContent
                .slotsRegistrationHeadScopeTopUpAdditional;
            array3.map((x) => {
              x.isTopup = true;
              x.selectedMainGroupId = x.mainGroupId;
              x.selectedWorkheadId = x.mainWorkHeadId;
              return x;
            });
            res.slotsRegistrationHeadScopeTopUpAdditional = array3;
            // we assign renewal pricing values using another saperate api GetRenewalSLOTsRegistrationHeadByMemberId
            // res.renewalSLOTSRegistrationHeadScope =
            //   response.responseItem.responseContent.renewalSLOTSRegistrationHeadScope;
            res.priceCalculator =
              response.responseItem.responseContent.priceCalculator;
            // res.renewalPriceCalculator =
            //   response.responseItem.responseContent.renewalPriceCalculator;
            res.statusId = response.responseItem.responseContent.statusId;
            res.workshopProofPath =
              response.responseItem.responseContent.workshopProofPath;
            res.supportingDocFormAOngoing =
              response.responseItem.responseContent.supportingDocFormAOngoing;
            res.supportingDocFormAOnComplete =
              response.responseItem.responseContent.supportingDocFormAOnComplete;
            /// New Renewal fields
            res.formA =
              response.responseItem.responseContent.formA;
            res.supportingDocFormA =
              response.responseItem.responseContent.supportingDocFormA;
            ///////// ----
            let renewalLength =
              response.responseItem.responseContent
                .renewalSLOTSRegistrationHeadScope.length;

            // let foreginPermitObj = this.state.foreignWorkPermitHolderList?.find(foreignWorkPermitHolder => foreignWorkPermitHolder.value === res.foreignWorkPermitHolderId)
            // res.foreignWorkPermitHolderLabel = foreginPermitObj.label;

            let data1 =
              response.responseItem.responseContent
                .latest6monthsCPFContribution;
            let arr1 = [];
            if (data1) {
              arr1 = data1.split(",");
            }
            res.fileList2 = [...arr1];

            let data3 =
              response.responseItem.responseContent.uploadWPOnlineRecord;
            let arr3 = [];
            if (data3) {
              arr3 = data3.split(",");
            }
            res.fileListOfWPRecord = [...arr3];

            let data4 =
              response.responseItem.responseContent
                .copyOfCPFContributionsOfCompletedProjects;
            let arr4 = [];
            if (data4) {
              arr4 = data4.split(",");
            }
            res.fileListOfcopyofcpfContribution = [...arr4];

            let data5 =
              response.responseItem.responseContent
                .approvedTechnicalQualification;
            let arr5 = [];
            if (data5) {
              arr5 = data5.split(",");
            }
            res.fileListOfApprovedTechnicalQualification = [...arr5];

            let data6 =
              response.responseItem.responseContent
                .companyBankStatementsOf6Month;
            let arr6 = [];
            if (data6) {
              arr6 = data6.split(",");
            }
            res.bankAccountStatementList = [...arr6];

            let data7 =
              response.responseItem.responseContent.supportingDocFormAOngoing;
            let arr7 = [];
            if (data7) {
              arr7 = data7.split(",");
            }
            res.formAOnGoingList = [...arr7];

            let data8 =
              response.responseItem.responseContent
                .supportingDocFormAOnComplete;
            let arr8 = [];
            if (data8) {
              arr8 = data8.split(",");
            }
            res.formACompletedList = [...arr8];

            let data9 =
              response.responseItem.responseContent.supportingDocFormA;
            let arr9 = [];
            if (data9) {
              arr9 = data9.split(",");
            }
            res.supportingDocFormAList = [...arr9];


            let data10 =
              response.responseItem.responseContent.projectTrackRecordsOfOnGoingProject;
            let arr10 = [];
            if (data10) {
              arr10 = data10.split(",");
            }
            res.formAOnGoingProjectList = [...arr10];

            let data11 =
              response.responseItem.responseContent.projectTrackRecordsOfCompletedProject;
            let arr11 = [];
            if (data11) {
              arr11 = data11.split(",");
            }
            res.projectTrackRecordsOfCompletedList = [...arr11];

            let data12 =
              response.responseItem.responseContent.formA;
            let arr12 = [];
            if (data12) {
              arr12 = data12.split(",");
            }
            res.formAList = [...arr12];

            // let data13 =
            //   response.responseItem.responseContent
            //     .approvedTechnicalQualification;
            // let arr13 = [];
            // if (data13) {
            //   arr5 = data13.split(",");
            // }
            // res.fileListOfApprovedTechnicalQualification = [...arr13];

            let data14 =
              response.responseItem.responseContent.uploadCorporatebankRecords;
            let arr14 = [];
            if (data14) {
              arr14 = data14.split(",");
            }
            res.fileListCorporatebankRecords = [...arr14];

            res.isPaymentLinkSentForRenewal = response.responseItem.responseContent.isPaymentLinkSentForRenewal;

            res.isForceRenewal = response.responseItem.responseContent.isForceRenewal;
            res.isExpiredMember = response.responseItem.responseContent.isExpiredMember;

            // this.setState({ SLOTSApplicationDetails: res, renewalDataLength: renewalLength });
            this.setState({
              isBasicApplicationLoading: false,
              isOrganisationProfileLoading: false,
              isRegisteringasSlots: isRegisteringasSlots,
              isConfirmedCRS: isConfirmedCRS,
              SLOTSApplicationDetails: res,
              renewalDataLength: renewalLength,
              wPOnlineRecordCount: res.fileListOfWPRecord.length,
              cpfContributionLocalCount: res.fileList2.length,
              copyofcpfContributionLocalCount: res.fileListOfcopyofcpfContribution.length,
              approvedTechnicalQualificationCount: res.fileListOfApprovedTechnicalQualification.length,
              companyBankAccStatementCount: res.bankAccountStatementList.length,
              supportingDocOngoingFileUploadCount: res.formAOnGoingList.length,
              supportingDocCompleteFileUploadCount: res.formACompletedList.length,
              onGoingProjectFileUploadCount: res.formAOnGoingProjectList.length,
              completedProjectFileUploadCount: res.projectTrackRecordsOfCompletedList.length,
              corporatebankRecordCount: res.fileListCorporatebankRecords.length,
              IsProbationaryAtStart: response.responseItem.responseContent.isProbationaryAtStart
            });

            if (res.statusId === 21) {
              this.setState({ isDisabledFlag: true });
            }
          }
        } else {
          this.swalServices.Error(response.message);
        }
        // this.setState({ isLoading: false });
      });
    // }
  };

  // Get Dropdown of Workhead and Grade Method
  getDropdownDataOfWorkheadAndGrade = (id, identity) => {
    let request = {};
    request.id = id;
    request.dropdownName = identity;
    this.slotMemberService
      .getDropdownDataOfWorkheadAndGrade(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          //let data = response.responseItem.responseContent;
          if (identity === "Workhead") {
            var ScopeWorkhead = response.responseItem.responseContent;
            ScopeWorkhead = ScopeWorkhead.map((p) => ({
              value: p.id,
              label: p.name,
            }));
            this.setState({ workheadList: ScopeWorkhead });
          } else if (identity === "Grade") {
            var gradeList = response.responseItem.responseContent;
            gradeList = gradeList.map((p) => ({ value: p.id, label: p.name }));
            this.setState({ gradeList: gradeList });
          } else if (identity === "Workhead2") {
            var workheadList = response.responseItem.responseContent;
            workheadList = workheadList.map((p) => ({
              value: p.id,
              label: p.name,
            }));
            this.setState({ workheadListPricing: workheadList });
          }
        }
      });
  };

  // SLOTS Member Validation Method Declaration Section Start
  validateSLOTSMember = (key, identity) => {

    let data = { ...SLOTSMemberValidationRules };
    data.paidUpCapitalValidationRule = this.state.paidUpCapitalValidationRule;
    data.uploadWPOnlineRecord = this.state.uploadWPOnlineRecordValRule;
    if (identity === "Organisation_Profile") {
      if (this.state.SLOTSApplicationDetails.companyTypeId === 1) {
        data.paidUpCapital = this.state.paidUpCapitalValidationRule
      }

    }
    const returnValidState = validate(
      key,
      this.state.SLOTSApplicationDetails,
      data,
      this.state.validStateSLOTSMember,
      this.state.validStateOrganisationProfile
    );

    this.setState({ validStateSLOTSMember: returnValidState, validStateOrganisationProfile: returnValidState });
  };

  isValidateAllFields1 = () => {

    const newValidState = {
      isValid: this.state.clarification.trim() !== "",
      error: {
        clarification: this.state.clarification.trim() === "" ? "Field is required." : "",
        // Other fields if applicable
      },
    };
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };
  isValidSLOTSMember = () => {

    let data = { ...SLOTSMemberValidationRules };

    if (this.state.SLOTSApplicationDetails.isCompanySafetyRelatedIssues) {
      data.specifyReason = this.state.specifyReason;
      data.moreInformation = this.state.moreInformation;
    } else if (this.state.SLOTSApplicationDetails.companyTypeId === 1) {
      data.paidUpCapital = this.state.paidUpCapitalValidationRule
    }

    // Removed condition using uploadWPOnlineRecordValRule

    const returnValidState = isValidForm(
      this.state.SLOTSApplicationDetails,
      data,
      this.state.validStateSLOTSMember
    );
    this.setState({ validStateSLOTSMember: returnValidState });
    return returnValidState.isValid;
  };


  // SLOTS Member Roles Validation Method Start
  validateSLOTSMemberRole = (key) => {
    const returnValidState = validate(
      key,
      this.state.roleDetails,
      SLOTSAuthorisedRepresentativeValidationRules,
      this.state.validStateSLOTSMemberRole
    );
    this.setState({ validStateSLOTSMemberRole: returnValidState });
  };



  isValidSLOTSMemberRole = () => {
    const returnValidState = isValidForm(
      this.state.roleDetails,
      SLOTSAuthorisedRepresentativeValidationRules,
      this.state.validStateSLOTSMemberRole
    );
    this.setState({ validStateSLOTSMemberRole: returnValidState });
    return returnValidState.isValid;
  };

  // SLOTS Member BCA Scope validation Method Start
  validateBCAScope = (key) => {
    const returnValidState = validate(
      key,
      this.state.selectedBuildingConScope,
      SLOTSMemberBCAScopeValidationRules,
      this.state.validStateBCAScope
    );
    this.setState({ validStateBCAScope: returnValidState });
  };
  isValidBCAScope = () => {
    const returnValidState = isValidForm(
      this.state.selectedBuildingConScope,
      SLOTSMemberBCAScopeValidationRules,
      this.state.validStateBCAScope
    );
    this.setState({ validStateBCAScope: returnValidState });
    return returnValidState.isValid;
  };


  validateOrganisationProfile = (key) => {
    const returnValidState = validate(
      key,
      this.state.SLOTSApplicationDetails,
      SLOTSMemberOrganisationProfileValidationRules,
      this.state.validStateOrganisationProfile,
      this.state.paidUpCapitalValidationRule
    );
    this.setState({ validStateOrganisationProfile: returnValidState });
  };
  isValidOrganisationProfile = () => {
    const returnValidState = isValidForm(
      this.state.SLOTSApplicationDetails,
      SLOTSMemberOrganisationProfileValidationRules,
      this.state.validStateOrganisationProfile,
      this.state.paidUpCapitalValidationRule
    );
    this.setState({ validStateOrganisationProfile: returnValidState });
    return returnValidState.isValid;
  };


  // SLOTS Member Registration Scope validation Method Start
  validateRegistrationScope = (key) => {
    const returnValidState = validate(
      key,
      this.state.selectedSLOTSRegistrationScope,
      SLOTSMemberRegistrationScopeValidationRules,
      this.state.validStateregistrationScope
    );
    this.setState({ validStateregistrationScope: returnValidState });
  };
  isValidRegistrationScope = () => {
    const returnValidState = isValidForm(
      this.state.selectedSLOTSRegistrationScope,
      SLOTSMemberRegistrationScopeValidationRules,
      this.state.validStateregistrationScope
    );
    this.setState({ validStateregistrationScope: returnValidState });
    return returnValidState.isValid;
  };

  // Internal Data Handling Method
  // Method For Handle SLOTS Member Inputs
  handleChange = (event, identity, key, representativeId) => {
    let value = event.target.value ? event.target.value.toUpperCase() : "";
    let name = event.target.name;
    if (identity === "SLOTS_Information") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      detail[name] = value;
      this.setState({ SLOTSApplicationDetails: detail });
    } else if (identity === "Roles_Details") {
      let detail = this.state.roleDetails;
      detail[name] = value;
      this.setState({ roleDetails: detail });
    } else if (identity === "Role_Checkboxes") {
      let detail = this.state.roleDetails;
      detail[name] = !detail[name];
      this.setState({ roleDetails: detail });
    } else if (identity === "Radio_Company_Activities") {
      let detail = this.state.SLOTSApplicationDetails;
      detail[name] = !detail[name];
      this.setState({ SLOTSApplicationDetails: detail });
    } else if (identity === "Add_Organisation_Role") {
      if (this.isValidSLOTSMemberRole()) {
        let detail = { ...this.state.SLOTSApplicationDetails };
        const roleDetails = { ...this.state.roleDetails };
        if (roleDetails.authorisedRepresentativeId > 0) {
          const index = detail.authorisedRepresentativeSummaryList.findIndex(
            rep => rep.authorisedRepresentativeId === roleDetails.authorisedRepresentativeId
          );
          if (index !== -1) {
            detail.authorisedRepresentativeSummaryList[index] = roleDetails;
          }
        } else {
          detail.authorisedRepresentativeSummaryList.push(roleDetails);
        }
        this.setState({ SLOTSApplicationDetails: detail }, () => {
          this.addEditAuthoriseRepresentativeSummary(roleDetails);
          this.resetHandler("Reset_Role_Section");
        });
      }
    }
    else if (identity === "Add_BCA_Scope") {

      if (this.isValidBCAScope()) {
        let detail = { ...this.state.SLOTSApplicationDetails };
        detail.registeredBCAScopeList.push(this.state.selectedBuildingConScope);
        this.setState({ SLOTSApplicationDetails: detail });
        this.resetHandler("Reset_BCA_Scope_Section");
      }
    } else if (identity === "Add_SLOTS_Registration_Scope") {

      if (this.state.SLOTSApplicationDetails.statusId === 18) {
        this.swalServices.Error("Registration head is not allowed to update");
      }
      else {
        if (this.isValidRegistrationScope()) {
          let detail = { ...this.state.SLOTSApplicationDetails };
          let oldobj = [...detail.slotsRegistrationHeadScopeTopUp];
          let isExist = false;
          // detail.slotsRegistrationHeadScope.push(this.state.selectedSLOTSRegistrationScope);
          // this part tem commented
          let regScope = this.state.selectedSLOTSRegistrationScope;
          //    if(detail.slotsRegistrationHeadScope.length > 0){
          //     detail.slotsRegistrationHeadScope.forEach(element => {
          //         if(element.workheadName === regScope.workheadName){
          //             isExist = true;
          //         }
          //     })

          //    }

          if (detail.slotsRegistrationHeadScopeTopUp.length > 0) {
            detail.slotsRegistrationHeadScopeTopUp.forEach((element) => {
              if (element.workheadName === regScope.workheadName) {
                isExist = true;
              }
            });
          }
          if (isExist === true) {
            this.swalServices.Error("You cannot duplicate ");
            this.resetHandler("Reset_SLOTS_Registration_Section");
          } else {
            //add here api call for add registration head TopUp++

            //after
            let request = {
              mainGroupId:
                this.state.selectedSLOTSRegistrationScope.selectedMainGroupId,
              workheadId:
                this.state.selectedSLOTSRegistrationScope.selectedWorkheadId,
              sLOTSMemberId: this.state.SLOTSApplicationDetails.slotsMemberId,

              // clarificationDetails: this.state.clarification,
            };
            //let request =  this.state.SLOTSApplicationDetails;
            this.setState({ isLoading: true });

            if (isExist === false) {
              //  detail.slotsRegistrationHeadScopeTopUp.push(this.state.selectedSLOTSRegistrationScope);
              detail.slotsRegistrationHeadScopeTopUp.push(
                this.state.selectedSLOTSRegistrationScope
              );
              this.setState({ SLOTSApplicationDetails: detail });
              //var creaditNoteId = this.state.SLOTSApplicationDetails.CreditNoteStatusId;
              //if (creaditNoteId != 2) {
              this.pricingCalculation();
              //}
            }

            let oldPrice = this.state.SLOTSApplicationDetails.priceCalculator;
            if (this.state.SLOTSApplicationDetails.statusId === 4) {
              if (this.state.priceCalculatorArray[2].Amount <= oldPrice[2].amount && oldPrice.length > 0) {
                const audit = getAuditContext()

                request.sameCategoryAmount = this.state.priceCalculatorArray[0].Amount;
                request.sameCategoryQuantity = this.state.priceCalculatorArray[0].quantity;
                request.existingCategoryAmount = this.state.priceCalculatorArray[1].Amount;
                request.existingCategoryQuantity = this.state.priceCalculatorArray[1].quantity;
                request.subtotalAmount = this.state.priceCalculatorArray[2].Amount;
                request.subtotalQuantity = this.state.priceCalculatorArray[2].quantity;
                request.updatedBy = audit.adminUserId;
                request.updatedAppId = audit.appId;

                this.slotMemberService
                  .AddSLOTSRegistrationHeadScopeTopUp(request)
                  .then((response) => {
                    if (
                      response.statusCode === 200 &&
                      response.responseItem != null
                    ) {
                      this.state.selectedSLOTSRegistrationScope.scopeId =
                        response.responseItem.responseContent.keyId;
                      //   this.swalServices.Success("Success");

                      this.resetHandler("Reset_SLOTS_Registration_Section");
                    } else {
                      this.resetHandler("Reset_SLOTS_Registration_Section");
                      this.swalServices.Error(response.message);
                    }
                    this.setState({ isLoading: false });
                  });
              } else {
                detail.slotsRegistrationHeadScopeTopUp = [...oldobj];
                this.setState({ SLOTSApplicationDetails: detail });

                this.resetHandler("Reset_SLOTS_Registration_Section");
                this.swalServices.Error("Update registration head is not allowed because your selected registration head pricing more than our current selected registration. if you still wants to add then use top-up functionality");
                this.setState({ isLoading: false }, () => {
                  this.pricingCalculation();
                });

              }
            } else {
              if (oldPrice.length > 0) {

                //if ((this.state.priceCalculatorArray[2].Amount <= oldPrice[2].amount && oldPrice.length > 0) || (this.state.SLOTSApplicationDetails.statusId === 1 || this.state.SLOTSApplicationDetails.statusId === 2 || this.state.SLOTSApplicationDetails.statusId === 15 || this.state.SLOTSApplicationDetails.statusId === 17)) {
                if (
                  //(this.state.priceCalculatorArray[2].Amount <= oldPrice[2].amount ||
                  (this.state.SLOTSApplicationDetails.statusId === 1 || this.state.SLOTSApplicationDetails.statusId === 2 || this.state.SLOTSApplicationDetails.statusId === 15 || this.state.SLOTSApplicationDetails.statusId === 16 || this.state.SLOTSApplicationDetails.statusId === 17
                    || this.state.SLOTSApplicationDetails.statusId === 22) && (this.state.SLOTSApplicationDetails.statusId !== 18)) {
                  //if ((oldPrice.length > 0) && (this.state.SLOTSApplicationDetails.statusId !== 18 || this.state.SLOTSApplicationDetails.statusId !== 22)) {
                  request.sameCategoryAmount = this.state.priceCalculatorArray[0].Amount;
                  request.sameCategoryQuantity = this.state.priceCalculatorArray[0].quantity;
                  request.existingCategoryAmount = this.state.priceCalculatorArray[1].Amount;
                  request.existingCategoryQuantity = this.state.priceCalculatorArray[1].quantity;
                  request.subtotalAmount = this.state.priceCalculatorArray[2].Amount;
                  request.subtotalQuantity = this.state.priceCalculatorArray[2].quantity;
                  this.slotMemberService
                    .AddSLOTSRegistrationHeadScopeTopUp(request)
                    .then((response) => {
                      if (
                        response.statusCode === 200 &&
                        response.responseItem != null
                      ) {
                        this.state.selectedSLOTSRegistrationScope.scopeId =
                          response.responseItem.responseContent.keyId;
                        //   this.swalServices.Success("Success");

                        this.resetHandler("Reset_SLOTS_Registration_Section");
                      } else {
                        this.resetHandler("Reset_SLOTS_Registration_Section");
                        this.swalServices.Error(response.message);
                      }
                      this.setState({ isLoading: false });
                    });
                } else {
                  detail.slotsRegistrationHeadScopeTopUp = [...oldobj];
                  this.setState({ SLOTSApplicationDetails: detail });

                  this.resetHandler("Reset_SLOTS_Registration_Section");
                  this.swalServices.Error("Update registration head is not allowed");
                  this.setState({ isLoading: false }, () => {
                    this.pricingCalculation();
                  });
                }
              } else {
                detail.slotsRegistrationHeadScopeTopUp = [...oldobj];
                this.setState({ SLOTSApplicationDetails: detail });

                this.resetHandler("Reset_SLOTS_Registration_Section");
                this.swalServices.Error("Update registration head is not allowed");
                this.setState({ isLoading: false }, () => {
                  //if (creaditNoteId != 2) {
                  this.pricingCalculation();
                  //}
                });
              }
            }
          }
        }
      }


    } else if (identity === "Add_SLOTS_Registration_Scope_Additional") {

      const detail = this.state.SLOTSApplicationDetails;
      const regScope = this.state.selectedSLOTSRegistrationScope;

      const oldScopes =
        detail.slotsRegistrationHeadScopeTopUp || [];

      const additionalScopes =
        detail.slotsRegistrationHeadScopeTopUpAdditional || [];

      const selectedMainGroupId =
        regScope.selectedMainGroupId || regScope.mainGroupId;

      const selectedWorkheadId =
        regScope.selectedWorkheadId || regScope.mainWorkHeadId;

      /*
       * ---------------------------------------------------------
       * 1. CHECK DUPLICATE WORKHEAD
       * ---------------------------------------------------------
       *
       * Same Workhead is not allowed.
       *
       * Same Main Group + different Workhead is allowed,
       * except when it is the free second head case below.
       */

      const isDuplicate = [
        ...oldScopes,
        ...additionalScopes
      ].some((item) => {

        const existingWorkheadId =
          item.selectedWorkheadId || item.mainWorkHeadId;

        const existingWorkheadName =
          item.workheadName;

        return (
          (selectedWorkheadId &&
            existingWorkheadId &&
            selectedWorkheadId === existingWorkheadId)
          ||
          (!selectedWorkheadId &&
            existingWorkheadName === regScope.workheadName)
        );
      });

      if (isDuplicate) {

        this.swalServices.Error(
          "You cannot duplicate"
        );

        this.resetHandler(
          "Reset_SLOTS_Registration_Section"
        );

        return;
      }


      /*
       * ---------------------------------------------------------
       * 2. COUNT EXISTING HEADS FOR THIS MAIN GROUP
       * ---------------------------------------------------------
       */

      const existingMainGroupCount =
        oldScopes.filter((item) => {

          const mainGroupId =
            item.selectedMainGroupId || item.mainGroupId;

          return mainGroupId === selectedMainGroupId;

        }).length;


      /*
       * ---------------------------------------------------------
       * 3. COUNT NEW / UNSAVED HEADS FOR THIS MAIN GROUP
       * ---------------------------------------------------------
       */

      const additionalMainGroupCount =
        additionalScopes.filter((item) => {

          const mainGroupId =
            item.selectedMainGroupId || item.mainGroupId;

          return mainGroupId === selectedMainGroupId;

        }).length;


      /*
       * ---------------------------------------------------------
       * 4. CHECK FREE SECOND HEAD
       * ---------------------------------------------------------
       *
       * Existing:
       *      M&E -> ME01
       *
       * Adding:
       *      M&E -> ME02
       *
       * Total becomes 2.
       *
       * The second head is FREE and should be handled through
       * Update Registration, NOT Top-Up Additional.
       */

      const totalHeadCount =
        existingMainGroupCount +
        additionalMainGroupCount;


      if (
        existingMainGroupCount === 1 &&
        totalHeadCount === 1
      ) {

        this.swalServices.Error(
          "You cannot add this registration TredHead(s) as TopUp Additional, But You can update registration TredHead(s)"
        );

        this.resetHandler(
          "Reset_SLOTS_Registration_Section"
        );

        return;
      }


      /*
       * ---------------------------------------------------------
       * 5. ADD NEW WORKHEAD TO FRONTEND
       * ---------------------------------------------------------
       */

      const tempDetail = {
        ...detail,
        slotsRegistrationHeadScopeTopUpAdditional: [
          ...additionalScopes,
          {
            ...regScope
          }
        ]
      };

      this.setState(
        {
          SLOTSApplicationDetails: tempDetail
        },
        () => {

          /*
           * Calculate price using the complete list.
           */
          const pricingData =
            this.pricingCalculationAdditional();

          const calculatedPrice =
            pricingData[2].Amount;


          /*
           * -------------------------------------------------
           * 6. IF PRICE > 0
           * SAVE AS TOP-UP
           * -------------------------------------------------
           */

          if (calculatedPrice > 0) {

            const request = {
              mainGroupId:
                regScope.selectedMainGroupId,

              workheadId:
                regScope.selectedWorkheadId,

              sLOTSMemberId:
                this.state.SLOTSApplicationDetails
                  .slotsMemberId,

              isRenewal:
                this.state.SLOTSApplicationDetails
                  .isRenewal,
            };

            this.setState(
              { isLoading: true }
            );

            this.slotMemberService
              .AddSLOTSRegistrationHeadScopeTopUpAdditional(
                request
              )
              .then((response) => {

                if (
                  response.statusCode === 200 &&
                  response.responseItem != null
                ) {

                  const scopeId =
                    response.responseItem
                      .responseContent.keyId;

                  this.setState(
                    (prevState) => {

                      const updatedList =
                        prevState
                          .SLOTSApplicationDetails
                          .slotsRegistrationHeadScopeTopUpAdditional
                          .map((item) => {

                            if (
                              item.workheadName ===
                              regScope.workheadName
                            ) {

                              return {
                                ...item,
                                scopeId:
                                  scopeId
                              };
                            }

                            return item;
                          });

                      return {
                        SLOTSApplicationDetails: {
                          ...prevState
                            .SLOTSApplicationDetails,

                          slotsRegistrationHeadScopeTopUpAdditional:
                            updatedList
                        }
                      };
                    },
                    () => {

                      this.pricingCalculationAdditional();

                      this.resetHandler(
                        "Reset_SLOTS_Registration_Section"
                      );
                    }
                  );

                }
                else {

                  this.swalServices.Error(
                    response.message
                  );

                  const currentDetail =
                    this.state.SLOTSApplicationDetails;

                  const filteredList =
                    currentDetail
                      .slotsRegistrationHeadScopeTopUpAdditional
                      .filter(
                        (item) =>
                          item.workheadName !==
                          regScope.workheadName
                      );

                  this.setState(
                    {
                      SLOTSApplicationDetails: {
                        ...currentDetail,

                        slotsRegistrationHeadScopeTopUpAdditional:
                          filteredList
                      }
                    },
                    () => {
                      this.pricingCalculationAdditional();
                    }
                  );

                  this.resetHandler(
                    "Reset_SLOTS_Registration_Section"
                  );
                }

                this.setState({
                  isLoading: false
                });
              })
              .catch(() => {

                this.swalServices.Error(
                  "An error occurred during save."
                );

                this.setState({
                  isLoading: false
                });

                this.resetHandler(
                  "Reset_SLOTS_Registration_Section"
                );
              });

          }

          /*
           * -------------------------------------------------
           * 7. PRICE = 0
           * -------------------------------------------------
           *
           * Normally this should NOT happen because we block
           * the free-second-head case above.
           */

          else {

            const filteredList =
              this.state.SLOTSApplicationDetails
                .slotsRegistrationHeadScopeTopUpAdditional
                .filter(
                  (item) =>
                    item.workheadName !==
                    regScope.workheadName
                );

            this.setState({
              SLOTSApplicationDetails: {
                ...this.state.SLOTSApplicationDetails,

                slotsRegistrationHeadScopeTopUpAdditional:
                  filteredList
              }
            });

            this.resetHandler(
              "Reset_SLOTS_Registration_Section"
            );

            this.swalServices.Error(
              "You cannot add this registration TredHead(s) as TopUp Additional, But You can update registration TredHead(s)"
            );
          }
        }
      );
    }
    else if (identity === "Remove_Organisation_Role") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      detail.authorisedRepresentativeSummaryList.splice(key, 1);
      this.setState({ SLOTSApplicationDetails: detail });
      this.removeSLOTSAuthoriseRepresentativeSummary(representativeId);
    } else if (identity === "Remove_BCA_Scope") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      detail.registeredBCAScopeList.splice(key, 1);
      this.setState({ SLOTSApplicationDetails: detail });
    } else if (identity === "Remove_SLOTS_Registration_Scope") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      detail.slotsRegistrationHeadScope.splice(key, 1);
      this.setState({ SLOTSApplicationDetails: detail });
    } else if (identity === "Remove_SLOTS_Registration_Scope_topup") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      detail.slotsRegistrationHeadScopeTopUp.splice(key, 1);
      this.setState({ SLOTSApplicationDetails: detail });
      this.pricingCalculation();
    }
  };

  // Method to add roles and scope
  handleAddRolesAndScope = (scope) => {
    if (scope === "BCA_Scope") {
      if (this.isValidBCAScope()) {
        let data = { ...this.state.SLOTSApplicationDetails };
        let bcaScope = this.state.selectedBuildingConScope;
        let isExist = false;
        if (data.registeredBCAScopeList.length > 0) {
          data.registeredBCAScopeList.forEach((element) => {
            if (

              element.workheadName === bcaScope.workheadName &&
              element.gradeName === bcaScope.gradeName
            ) {
              isExist = true;
            }
          });
        }
        if (isExist === true) {
          this.swalServices.Error("you cannot duplicate role");
        } else {
          data.registeredBCAScopeList.push(this.state.selectedBuildingConScope);
          this.resetHandler("Reset_BCA_Scope_Section");
        }
        this.setState({ SLOTSApplicationDetails: data });
      }
    }
  };

  // Method to remove roles and scope
  handleRemoveRolesAndScope = (key, scope) => {
    if (scope === "BCA_Scope") {
      const list = { ...this.state.SLOTSApplicationDetails };
      list.registeredBCAScopeList.splice(key, 1);
      this.setState({ SLOTSApplicationDetails: list });
    }
  };

  updateSLOTSRegistrationHeadScopeTopUp = () => {
    const audit = getAuditContext();

    let request = {};
    request.sameCategoryAmount = this.state.priceCalculatorArray[0].Amount;
    request.sameCategoryQuantity = this.state.priceCalculatorArray[0].quantity;
    request.existingCategoryAmount = this.state.priceCalculatorArray[1].Amount;
    request.existingCategoryQuantity = this.state.priceCalculatorArray[1].quantity;
    request.subtotalAmount = this.state.priceCalculatorArray[2].Amount;
    request.subtotalQuantity = this.state.priceCalculatorArray[2].quantity;
    request.slotsMemberId = this.state.slotsMemberId;
    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.slotMemberService
      .updateSLOTSRegistrationHeadScopeTopUp(request)
      .then((response) => {
        if (
          response.statusCode === 200 &&
          response.responseItem != null
        ) {
          this.swalServices.Success("Update successfully.");
          this.getSLOTSMemberDetailByMemberId(this.state.slotsMemberId);
        } else {
          this.swalServices.Error(response.message);
        }
      });
  }

  removeRenewalRegistrationHead = (event, key) => {

    if (this.state.SLOTSApplicationDetails.statusId === 18) {
      this.swalServices.Error("Registration head is not allowed to delete.");
    } else {

      this.swalServices
        .Confirm(
          CommonSuccessMessages.Confirm_RemoveSlotsRegistrationHeadTopUp.replace(
            "{0}",
            "Admin"
          ),
          "",
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        )
        .then((response) => {
          if (response) {
            let scopeId;
            let detail = { ...this.state.SLOTSApplicationDetails };

            scopeId = detail.renewalSLOTSRegistrationHeadScope[key].scopeId


            this.removeSLOTSRegistrationHeadScopeTopUp(scopeId);

            detail.renewalSLOTSRegistrationHeadScope.splice(key, 1);




            this.setState({ SLOTSApplicationDetails: detail });
            //var creaditNoteId = this.state.SLOTSApplicationDetails.CreditNoteStatusId;
            //if (creaditNoteId != 2) {

            //this.pricingCalculation();
            this.calculateRenewalPrice()
            //}
            this.setState({ SLOTSApplicationDetails: detail }, () => {
              if ((this.state.SLOTSApplicationDetails.statusId === 1 || this.state.SLOTSApplicationDetails.statusId === 2 || this.state.SLOTSApplicationDetails.statusId === 15 || this.state.SLOTSApplicationDetails.statusId === 17)
                || (this.state.SLOTSApplicationDetails.statusId !== 18 || this.state.SLOTSApplicationDetails.statusId == 22)) {
                this.setSLOTsMemberPricing(true);
              }
            });
            this.GetRenewalSLOTsRegistrationHeadByMemberId(detail.slotsMemberId)
          }
        });
    }

  };
  removeRegistrationHead = (event, key) => {

    if (this.state.SLOTSApplicationDetails.statusId === 18) {
      this.swalServices.Error("Registration head is not allowed to delete.");
    } else {

      this.swalServices
        .Confirm(
          CommonSuccessMessages.Confirm_RemoveSlotsRegistrationHeadTopUp.replace(
            "{0}",
            "Admin"
          ),
          "",
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        )
        .then((response) => {
          if (response) {
            let scopeId;
            let detail = { ...this.state.SLOTSApplicationDetails };


            scopeId = detail.slotsRegistrationHeadScopeTopUp[key].scopeId

            this.removeSLOTSRegistrationHeadScopeTopUp(
              scopeId
            );

            detail.slotsRegistrationHeadScopeTopUp.splice(key, 1);


            this.setState({ SLOTSApplicationDetails: detail });
            //var creaditNoteId = this.state.SLOTSApplicationDetails.CreditNoteStatusId;
            //if (creaditNoteId != 2) {

            this.pricingCalculation();
            //this.calculateRenewalPrice()
            //}
            this.setState({ SLOTSApplicationDetails: detail }, () => {
              if ((this.state.SLOTSApplicationDetails.statusId === 1 || this.state.SLOTSApplicationDetails.statusId === 2 || this.state.SLOTSApplicationDetails.statusId === 15 || this.state.SLOTSApplicationDetails.statusId === 17)
                || (this.state.SLOTSApplicationDetails.statusId !== 18 || this.state.SLOTSApplicationDetails.statusId == 22)) {
                this.setSLOTsMemberPricing(false);
              }
            });
            this.GetRenewalSLOTsRegistrationHeadByMemberId(detail.slotsMemberId)
          }
        });
    }

  };

  setSLOTsMemberPricing = (isRenewal) => {

    let request = {};

    request.isRenewal = isRenewal;
    if (isRenewal == true) {

      request.slotsMemberId = this.state.slotsMemberId;
      request.sameCategoryAmount = this.state.renewalPriceCalculatorArray[0].Amount;
      request.sameCategoryQuantity = this.state.renewalPriceCalculatorArray[0].quantity;
      request.existingCategoryAmount = this.state.renewalPriceCalculatorArray[1].Amount;
      request.existingCategoryQuantity = this.state.renewalPriceCalculatorArray[1].quantity;
      request.subtotalAmount = this.state.renewalPriceCalculatorArray[2].Amount;
      request.subtotalQuantity = this.state.renewalPriceCalculatorArray[2].quantity;
    } else {
      request.slotsMemberId = this.state.slotsMemberId;
      request.sameCategoryAmount = this.state.priceCalculatorArray[0].Amount;
      request.sameCategoryQuantity = this.state.priceCalculatorArray[0].quantity;
      request.existingCategoryAmount = this.state.priceCalculatorArray[1].Amount;
      request.existingCategoryQuantity = this.state.priceCalculatorArray[1].quantity;
      request.subtotalAmount = this.state.priceCalculatorArray[2].Amount;
      request.subtotalQuantity = this.state.priceCalculatorArray[2].quantity;
    }
    if (this.state.SLOTSApplicationDetails.statusId !== 4) {
      this.slotMemberService
        .setSLOTsMemberPricing(request)
        .then((response) => {
          if (
            response.statusCode === 200 &&
            response.responseItem != null
          ) {
            //this.state.selectedSLOTSRegistrationScope.scopeId =
            // response.responseItem.responseContent.keyId;
            //   this.swalServices.Success("Success");

            //this.resetHandler("Reset_SLOTS_Registration_Section");
          }
          this.setState({ isLoading: false });
        });
    }

  }

  removeRegistrationHeadAdditional = (event, key) => {
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_RemoveSlotsRegistrationHeadTopUpAdditional.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          let detail = { ...this.state.SLOTSApplicationDetails };
          this.removeSLOTSRegistrationHeadScopeTopUpAdditional(
            detail.slotsRegistrationHeadScopeTopUpAdditional[key].scopeId
          );
          detail.slotsRegistrationHeadScopeTopUpAdditional.splice(key, 1);
          this.setState({ SLOTSApplicationDetails: detail });
          this.pricingCalculationAdditional();
        }
      });
  };

  saveClarificationDetails = () => {
    const audit = getAuditContext();

    let isValidInput = this.isValidateAllFields1();
    if (isValidInput) {
      this.setState({ setSendClarifications: true });
      this.swalServices
        .Confirm(
          CommonSuccessMessages.Confirm_SendClarifications.replace(
            "{0}",
            "Admin"
          ),
          "",
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        ).then((response) => {
          if (response) {
            let request = {
              slotMemberId: this.state.SLOTSApplicationDetails.slotsMemberId,
              clarificationDetails: this.state.clarification,
              statusId: this.state.SLOTSApplicationDetails.statusId,
              updatedBy: audit.adminUserId,
              updatedAppId: audit.appId,
            };
            //
            this.setState({ isLoading: true });
            this.slotMemberService
              .SaveSlotMemberClarificationDetails(request)
              .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                  this.swalServices.Success("Clarification mail sent successfully");
                  this.setState({ setSendClarifications: false });
                  this.setState({ clarification: "" });
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
              });
          } else {
            this.setState({ isLoading: false });
            this.setState({ setSendClarifications: false });

          }
        });
    }
  };

  saveSendRejectionReasonDetails = () => {
    const audit = getAuditContext();

    let request = {
      slotMemberId: this.state.SLOTSApplicationDetails.slotsMemberId,
      clarificationDetails: this.state.sendRejectionReason,
      updatedBy: audit.adminUserId,
      updatedAppId: audit.appId,

    };
    this.setState({ isLoadingRejectAplication: true });
    this.slotMemberService
      .SaveSlotMemberClarificationDetails(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success("Clarification mail sent successfully");
          this.setState({ setRejectionReason: false });
          this.setState({ sendRejectionReason: "" });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingRejectAplication: false });
      });
  };

  editSlotsMemberDetails = () => {
    const audit = getAuditContext();

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_update_slotsMemebr_Information.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {

          if (this.isValidSLOTSMember()) {
            let request = this.state.SLOTSApplicationDetails;
            request.updatedBy = this.state.updatedBy;
            request.updatedAppId = this.state.updatedAppId;
            request.IsRegisteringasSlots = this.state.isRegisteringasSlots;
            request.IsConfirmedCRS = this.state.isConfirmedCRS;
            request.updatedBy = audit.adminUserId;
            request.updatedAppId = audit.appId;

            if (request.isCompanyActivities === false) {
              request.registeredBCAScopeList = [];
            }

            this.setState({ isLoading: true });
            this.slotMemberService
              .EditSlotsMemberDetails(request)
              .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {

                  this.swalServices.Success(
                    "Slots Member Details Updated successfully"
                  );

                  this.getSLOTSMemberDetailByMemberId(
                    this.state.SLOTSApplicationDetails.slotsMemberId
                  );
                  this.getAllDropDownsForSLOTSMember();
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
              });
          }
        }
      });
  };

  rejectSLOTSMemberApplication = (flag) => {
    const audit = getAuditContext();

    let reject = this.state.sendRejectionReason;


    if ((reject && reject !== null) || flag === "UnReject") {
      let request = {};
      if (flag !== "UnReject") {

      }
      request.slotsMemberId = this.state.SLOTSApplicationDetails.slotsMemberId;
      request.sendRejectionReason = reject;
      if (flag === "Rejected") {
        request.isRejected = true;
      } else if (flag === "UnReject") {
        request.isRejected = false;
      }
      this.setState({ isLoadingRejectAplication: true });

      request.updatedBy = audit.adminUserId;
      request.updatedAppId = audit.appId;

      this.swalServices
        .Confirm(
          request.isRejected === false ? CommonSuccessMessages.Confirm_Appeal_Process.replace(
            "{0}",
            "Admin"
          ) : CommonSuccessMessages.Confirm_Reject_Application.replace(
            "{0}",
            "Admin"
          ),
          "",
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        ).then((response) => {
          if (response) {
            this.slotMemberService
              .rejectSLOTSMemberApplication(request)
              .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                  this.swalServices.Success(`Slots Member ${flag} successfully`);
                  this.setState({ route: "/Membership/SLOTAccreditation" });
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isLoadingRejectAplication: false });
              });
          } else {
            this.setState({ isLoadingRejectAplication: false });

          }

        });

    } else {
      this.swalServices.Error("Please enter detail");
    }
  };

  ExpireSlotsMemberApplication = () => {

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_ExpireSlots.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {
          this.setState({ isLoadingExpireApplication: true });

          this.slotMemberService
            .ExpireSlotsMemberApplication(
              this.state.SLOTSApplicationDetails.slotsMemberId
            )
            .then((response) => {
              if (response.statusCode === 200 && response.responseItem != null) {
                this.swalServices.Success(`Slots member exprire successfully`);
                this.getSLOTSMemberDetailByMemberId(
                  this.state.SLOTSApplicationDetails.slotsMemberId
                );
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoadingExpireApplication: false });
            });
        }
      })


  };

  handleChangeClarificationDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        clarification: data,
      });
    }
  };

  handleChangeSendRejectionReasonDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        sendRejectionReason: data,
      });
      this.setState({ sendRejectionReason: data });
    }

  };

  setSendClarificationsFlag = () => {
    this.setState({ setSendClarifications: true });
  };

  setSendRejectionReasonFlag = () => {
    this.setState({ setRejectionReason: true });
  };

  sendReconciliationUploadWorkshopProofLinkToSlots = (IsProbationary) => {

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_SendWorkShopProffUploadLink.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {
          let request = {
            slotsMemberId: this.state.SLOTSApplicationDetails.slotsMemberId,
            companyName: this.state.SLOTSApplicationDetails.companyName,
            firstName: this.state.SLOTSApplicationDetails.headOfCompanyFirstName,
            lastName: this.state.SLOTSApplicationDetails.headOfCompanyLastName,
            email: this.state.SLOTSApplicationDetails.businessEmail,
            isProbationary: IsProbationary
          };
          this.setState({ isWorkshopProofLoader: true });
          this.slotMemberService
            .SendReconciliationUploadWorkshopProofLinkToSlots(request)
            .then((response) => {
              if (response.statusCode === 200 && response.responseItem != null) {
                this.swalServices.Success(
                  "Upload Workshop Proof Link mail sent successfully"
                );
                this.setState({ setSendClarifications: false });
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isWorkshopProofLoader: false });
              this.getSLOTSMemberDetailByMemberId(this.state.slotsMemberId);
            });
        }
      });

  };

  // Handle Change Method For Dropdown Select
  handleChangeInDropdown = (selected, identity) => {

    if (identity === "Country") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      if (selected.value === "*") {
        detail.countryId = 0;
      } else {
        detail.countryId = selected.value;
      }

      this.setState({ SLOTSApplicationDetails: detail });
    }
    else if (identity === "Annual_Turnover") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      if (selected.value === "*") {
        detail.annualTurnOverId = 0;
      } else {
        detail.annualTurnOverId = selected.value;
      }
      this.setState({ SLOTSApplicationDetails: detail });
    }
    else if (identity === "SlotProjectType") {
      let detail = { ...this.state.projectTrackRecordsDetails };
      if (selected.value === "*") {
        detail.projectType = 0;
      } else {
        detail.projectType = selected.value;
      }
      this.setState({ projectTrackRecordsDetails: detail });
    }
    else if (identity === "Registered_CompanyType_List") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      if (selected.value === "*") {
        detail.companyTypeId = 0;
      } else {
        detail.companyTypeId = selected.value;
      }
      // if (detail.companyTypeId !== 4) {
      //   detail.specifyOtherCompanyType = null;
      // }
      this.setState({ SLOTSApplicationDetails: detail });
    }



    else if (identity === "Staff_Employee_Local") {
      let detail = { ...this.state.SLOTSApplicationDetails };
      if (selected.value === "*") {
        detail.numberOfStaffEmployedLocalId = 0;
      } else {
        detail.numberOfStaffEmployedLocalId = selected.value;
      }

      this.setState({ SLOTSApplicationDetails: detail });
    } else if (identity === "Role") {
      let detail = { ...this.state.roleDetails };
      detail.roleId = selected.value;
      detail.roles = selected.label;
      this.setState({ roleDetails: detail });
    } else if (identity === "Main_Group_Scope1") {
      let detail = { ...this.state.selectedBuildingConScope };
      detail.mainGroupId = selected.value;
      detail.mainGroupName = selected.label;
      detail.workheadId = 0;
      detail.gradeId = 0;
      detail.workheadName = "";
      detail.gradeName = "";
      this.setState(
        { selectedBuildingConScope: detail, workheadList: [], gradeList: [] },
        () => {
          this.getDropdownDataOfWorkheadAndGrade(selected.value, "Workhead");

        }
      );
    } else if (identity === "Workhead_Scope1") {
      let detail = { ...this.state.selectedBuildingConScope };
      detail.workheadId = selected.value;
      detail.workheadName = selected.label;
      detail.gradeId = 0;
      detail.gradeName = "";
      this.setState({ selectedBuildingConScope: detail, gradeList: [] }, () => {
        this.getDropdownDataOfWorkheadAndGrade(selected.value, "Grade");

      });
    } else if (identity === "Grade_Scope1") {
      let detail = { ...this.state.selectedBuildingConScope };
      detail.gradeId = selected.value;
      detail.gradeName = selected.label;
      this.setState({ selectedBuildingConScope: detail });
    } else if (identity === "Main_Group_Scope2") {
      let detail = { ...this.state.selectedSLOTSRegistrationScope };
      detail.selectedMainGroupId = selected.value;
      detail.mainGroupName = selected.label;
      detail.selectedWorkheadId = 0;
      detail.workheadName = "";
      detail.isTopup = true;
      this.setState(
        { selectedSLOTSRegistrationScope: detail, workheadListPricing: [] },
        () => {
          this.getDropdownDataOfWorkheadAndGrade(selected.value, "Workhead2");
        }
      );
    } else if (identity === "Workhead_Scope2") {
      let detail = { ...this.state.selectedSLOTSRegistrationScope };
      if (selected.value === "*") {
        detail.selectedWorkheadId = 0;
      } else {
        detail.selectedWorkheadId = selected.value;
      }
      detail.workheadName = selected.label;
      detail.isTopup = true;
      this.setState({ selectedSLOTSRegistrationScope: detail });
    }



    else if (identity === "Foreign_WorkPermit_Holder") {

      let detail = { ...this.state.SLOTSApplicationDetails };
      if (selected.value === "*") {
        detail.foreignWorkPermitHolderId = 0;
      } else {
        detail.foreignWorkPermitHolderId = selected.value;
        detail.foreignWorkPermitHolderLabel = selected.label;
      }



      this.setState({ SLOTSApplicationDetails: detail });
    }
  };

  resetHandler = (section) => {
    if (section === "Reset_Role_Section") {
      let reset = { ...this.state.roleDetails };
      reset.authorisedRepresentativeId = 0;
      reset.roleId = 0;
      reset.roles = "";
      reset.firstName = "";
      reset.lastName = "";
      reset.jobTitle = "";
      reset.directOfficeNumber = "";
      reset.mobileNumber = "";
      reset.emailAddress = "";
      reset.isNewsletter = false;
      reset.isTelegram = false;
      reset.isePortal = false;
      this.setState({ roleDetails: reset });
    } else if (section === "Reset_BCA_Scope_Section") {
      let reset = { ...this.state.selectedBuildingConScope };
      reset.scopeId = 0;
      reset.mainGroupId = 0;
      reset.workheadId = 0;
      reset.gradeId = 0;
      reset.mainGroupName = "";
      reset.workheadName = "";
      reset.gradeName = "";
      this.setState({ selectedBuildingConScope: reset });
    } else if (section === "Reset_SLOTS_Registration_Section") {
      let reset = { ...this.state.selectedSLOTSRegistrationScope };
      reset.scopeId = 0;
      reset.selectedMainGroupId = 0;
      reset.selectedWorkheadId = 0;
      reset.mainGroupName = "";
      reset.workheadName = "";
      this.setState({ selectedSLOTSRegistrationScope: reset });
    }
  };

  handleRadioClick = async (event) => {

    const selectedValue = event.target.value;

    if (selectedValue === 'register') {
      this.setState({
        selectedValue: 'register',
        isRegisteringasSlots: true,
        isConfirmedCRS: false
      });
    } else if (selectedValue === 'optOut') {
      const result = await this.swalServices.Warnings("Please confirm that you will opt out from registering in CRS​");
      if (result.isConfirmed) {
        this.setState({
          selectedValue: 'optOut',
          isRegisteringasSlots: false,
          isConfirmedCRS: true
        });
      }
    }
  };

  sendPaymentLinkOfSLOTSMember = () => {
    this.setState({ isPaymentLinkLoader: true });
    this.slotMemberService
      .sendPaymentLinkOfSLOTSMember(this.state.slotsMemberId)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent != null) {
            this.swalServices.Success(
              "Payment Link has been sent successfully."
            );
            this.getSLOTSMemberDetailByMemberId(this.state.slotsMemberId);
          }
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isPaymentLinkLoader: false });
      });
  };

  acceptRenewSLOTSMembership = () => {
    this.setState({ isPaymentLinkLoader: true });
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_PaymentProffLinkForRenewal.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {

          this.slotMemberService
            .acceptRenewSLOTSMembership(this.state.slotsMemberId)
            .then((response) => {
              if (response.statusCode === 200 && response.responseItem != null) {
                if (response.responseItem.responseContent != null) {
                  this.swalServices.Success(
                    "Payment Link has been sent for renewal successfully."
                  );

                  let res = { ...this.state.SLOTSApplicationDetails };
                  res.isPaymentLinkSentForRenewal = true;
                  this.setState({
                    SLOTSApplicationDetails: res
                  })
                }
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isPaymentLinkLoader: false });
            });
        } else {
          this.setState({ isPaymentLinkLoader: true });
        }
      });
  };

  GetSlotsMemberFiles = (type, Filepath) => {
    if (Filepath) {
      let request = [
        this.state.SLOTSApplicationDetails.slotsMemberId,
        type,
        Filepath,
      ];
      this.slotMemberService.GetSlotsMemberFiles(request).then((response) => {
        if (response.data !== null && response.status === 200) {
          var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
          var filename = "";
          filename = `${type}${formattedDate}`;
          const extension = Filepath.split(".").pop();
          if (extension) {
            saveAs(new Blob([response.data]), `${filename}.${extension}`);
          }
        } else {
          this.swalServices.Error(response.message);
        }
      });
    } else {
      this.swalServices.Error("No data found");
    }
  };

  DownloadMultipleFilesZip = (type) => {

    let request = {};
    if (type === "ACRACertificates") {
      request = {
        FileList: this.state.arcaFiles,
        Type: type,
      };
    } else if (type === "WPOnlineRecord") {
      request = {
        FileList: this.state.wpOnlineRecordFiles,
        //FileList: this.state.SLOTSApplicationDetails.fileListOfWPRecord,
        Type: type,
      };
    } else if (type === "Latest6MonthsCPFcontribution") {
      request = {
        FileList: this.state.cPFcontributionFiles,
        Type: type,
      };
    } else if (type === "CopyOfCPFContributionsOfCompletedProjects") {
      request = {
        FileList: this.state.copyOfCPFContributionsOfCompletedProjectsList,
        Type: type,
      };
    } else if (type === "ApprovedTechnicalQualification") {
      request = {
        FileList: this.state.approvedTechnicalQualificationList,
        Type: type,
      };
    } else if (type === "BankAccountStatements") {
      request = {
        FileList: this.state.companyBankFiles,
        Type: type,
      };
    } else if (type === "supportingDocFormAOngoing") {
      request = {
        FileList: this.state.supportingDocFormAOngoingList,
        Type: type,
      };
    } else if (type === "supportingDocFormAOnComplete") {
      request = {
        FileList: this.state.supportingDocFormAOnCompleteList,
        Type: type,
      };
    } else if (type === "SupportingDocFormA") {
      request = {
        FileList: this.state.supportingDocFormAList,
        Type: type,
      };
    }
    else if (type === "ProjectTrackRecordsOfOnGoingProject") {
      request = {
        FileList: this.state.projectTrackOnGoingProjectList,
        Type: type,
      };
    }
    else if (type === "ProjectTrackRecordsOfOnCompletedProject") {
      request = {
        FileList: this.state.projectTrackRecordsOfCompletedList,
        Type: type,
      };
    }
    else if (type === "FormA") {
      request = {
        FileList: this.state.formAList,
        Type: type,
      };
    }
    else if (type === "Audit Reminder (18th Month)") {
      request = {
        FileList: this.state.auditReminder18thMonth,
        Type: 'SLOTSAuditDocuments',
      };
    }
    else if (type === "Certificate Attendance (9th Month)") {

      request = {
        FileList: this.state.CertificateAttendance9thMonth,
        Type: 'SLOTSAttendaceCertificate',
      };
    }
    else if (type === "Certificate Attendance (21st Month)") {
      request = {
        FileList: this.state.certificateAttendance21stMonth,
        Type: 'SLOTSAttendaceCertificate',
      };
    }

    if (request.FileList && request.FileList.length > 0) {
      this.setState({ isLoading: true });
      this.commonServices.DownloadMultipleFilesZip(request).then((response) => {
        if (response.data !== null && response.status === 200) {
          var blob = new Blob([response.data]);
          saveAs(blob, type + ".zip");
          this.setState({ isCreatingZip: false });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
    } else {
      this.swalServices.Error("No data found");
    }
  };
  handleChangeForProjectTractRecords = (event, identity) => {
    const value = event.target.value.toUpperCase();
    const name = event.target.name;
    let detail = this.state.projectTrackRecordsDetails;
    if (identity === "Prject_Tract_Records") {
      detail[name] = value;
      this.setState({ projectTrackRecordsDetails: detail });
    }
    // console.log("Project tract records datils", this.state.slotsApplicationDetail.projectTrackRecordsDetailsList);
    // console.log("projectTrackRecordsDetails", this.state.projectTrackRecordsDetails)
  }

  resetAllProjectTractRecordsFields = () => {
    const DEFAULT_PROJECT_TRACK_RECORDS_DETAILS = {
      projectTrackRecordID: 0,
      slotsMemberId: 0,
      contractNo: "",
      projectTitle: "",
      projectType: "",
      projectTypeId: 0,

      agency: "",
      projectLocation: "",
      dateOfCommencement: "",
      dateofCompletion: "",
      actualDateOfCompletion: "",
      awardValue: "",
      mainContractorName: "",
      mainContractorTelephoneNo: "",
      mainContractorEmail: "",
      contactPersonName: "",
      hasLetterOfAwardOrPO: "",
      hasInvoicesWithPaymentProof: "",
      hasCertificateOfCompletion: "",
      isCompleted: false,
      isOngoing: false,
      letterofAwardorPurchaseOrderList: [],
      ongoingProjectID: 0,

      completedProjectID: 0,
      letterofAwardorPurchaseOrderDocs: "",
      certificateOfCompletionPath: "",
      finalInvoiceFilePath: "",
      certificateofcompletionList: [],
      finalInvoiceFilePathList: [],
    };
    this.setState({
      certificateofcompletionCount: 0,
      LetterofAwardorPurchaseCount: 0,
      finalInvoiceFileCount: 0,
      projectTrackRecordsDetails: { ...DEFAULT_PROJECT_TRACK_RECORDS_DETAILS },
      certificateofcompletionList: [],
      letterofAwardorPurchaseOrderList: [],
      finalInvoiceFilePathList: [],
    });
  }

  AddEditProjectTrackRecord = (newProject) => {
    const audit = getAuditContext();

    this.state.projectTrackRecordsDetails.isOngoing = newProject.isOngoing;
    this.state.projectTrackRecordsDetails.isCompleted = newProject.isCompleted;
    const currentDetails = { ...this.state.projectTrackRecordsDetails };
    const isValid = this.isValidateAllFields("Add_Project");
    if (!isValid) {
      if (isValid) return;
      this.swalServices.Warning("Please fill remaing fields", "OK");
      //this.resetAllProjectTractRecordsFields();
    } else {
      const extractPaths = (list) =>
        Array.isArray(list)
          ? list.map(item => (typeof item === 'object' && item.path ? item.path : item)).join(",")
          : null;

      const request = {
        ...currentDetails,
        projectType: this.state.projectTrackRecordsDetails.projectType,
        isOngoing: newProject.isOngoing,
        isCompleted: newProject.isCompleted,
        slotsMemberId: this.state.slotsMemberId,
        letterofAwardorPurchaseOrderDocs: extractPaths(currentDetails.letterofAwardorPurchaseOrderList),
        certificateOfCompletionPath: extractPaths(currentDetails.certificateofcompletionList),
        finalInvoiceFilePath: extractPaths(currentDetails.finalInvoiceFilePathList),
        UserId: audit.adminUserId,
        AppId: audit.appId

      };

      this.setState({ isLoading: true });

      this.slotMemberService.addEditProjectTrackRecord(request).then((response) => {
        const content = response?.responseItem?.responseContent;

        if (response.statusCode === 200 && content) {
          this.GetAllProjectTrackRecordsById(this.state.slotsMemberId);

          const message = content.errorMessage === "ADDED" ? "Record Added..." : "Record updated...";
          this.swalServices.Success(message);

          this.resetAllProjectTractRecordsFields();
        } else {
          this.swalServices.Error(response.message || "Something went wrong.");
        }

        this.setState({ isLoading: false });
      });
    }
  };


  GetAllProjectTrackRecordsById = (slotsMemberId) => {
    if (slotsMemberId > 0) {
      this.slotMemberService.GetAllProjectTrackRecordsById(slotsMemberId)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            const listData = response.responseItem.responseContent;

            const completedProjectData = listData.filter(proj => proj.isCompleted === true);
            const ongoingProjectData = listData.filter(proj => proj.isOngoing === true);
            let certificateofcompletionCount = 0;
            let LetterofAwardorPurchaseCount = 0;
            let finalInvoiceFileCount = 0;
            this.setState({
              certificateofcompletionCount,
              LetterofAwardorPurchaseCount,
              finalInvoiceFileCount,
              projectTrackRecordsDetailsList: listData,
              completedProjectTrackRecordsDetailsList: completedProjectData,
              ongoingProjectTrackRecordsDetailsList: ongoingProjectData,
            });
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }

  };


  // On upload file change handle method
  onFileChange = (event, fileType) => {

    const files = Array.from(event.target.files);
    if (this.state.slotsMemberId > 0) {
      const file = event.target.files[0];
      if (file) {
        if (file.size < 5242880) {
          if (fileType === "Upload_WP_Record") {
            if (this.state.wPOnlineRecordCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" ||
                file.type === "application/vnd.ms-excel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.storagePath = "SLOTSMemberPDFs\\WPOnlineRecord";
                this.setState({ isWPRecordLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {

                  if (response !== null) {
                    if (response.isNotCurrupted === true) {
                      let detail = { ...this.state.SLOTSApplicationDetails };
                      detail["uploadWPOnlineRecord"] = response.fileName;
                      detail.fileListOfWPRecord.push(response.fileName);
                      this.setState(
                        {
                          wpOnlineRecordFiles: detail.fileListOfWPRecord.map((p) => ({ path: p })),
                          SLOTSApplicationDetails: detail,
                          wPOnlineRecordCount: this.state.wPOnlineRecordCount + 1,
                        },

                      );
                      this.saveSLOTsDocuments(
                        "UploadWPOnlineRecord",
                        "uploadWPOnlineRecord",
                        "Organisation_Profile"
                      );

                    } else {
                      this.swalServices.Error("Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isWPRecordLoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          else if (fileType === "Upload_corporate_bank_Record") {
            if (this.state.corporatebankRecordCount < 10) {
              if (file && (file.type === "image/jpeg" || file.type === "image/png" || file.type === "application/pdf")) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.corporatebankRecordCount + 1}`;
                uploadFile.storagePath = "SLOTSMemberPDFs\\CorporatebankRecords";

                this.setState({ isCorporatebankRecordsLoader: true });

                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response != null) {
                    if (response.isNotCurrupted === true) {
                      let detail = { ...this.state.SLOTSApplicationDetails };
                      detail["uploadCorporatebankRecords"] = response.fileName;
                      detail.fileListCorporatebankRecords.push(response.fileName);

                      this.setState({
                        bankAccountStatementList: detail.fileListCorporatebankRecords.map((p) => ({ path: p })),

                        SLOTSApplicationDetails: detail,
                        corporatebankRecordCount: this.state.corporatebankRecordCount + 1,
                      });

                      this.saveSLOTsDocuments('UploadCorporatebankRecords', "uploadCorporatebankRecords", "Organisation_Profile");
                    } else {
                      this.swalServices.Error("Document is invalid");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }

                  this.setState({ isCorporatebankRecordsLoader: false });
                });
              } else {
                this.swalServices.Error("Please upload only PDF, JPEG, JPG and PNG files & Max of 5MB!");
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }


          else if (fileType === "CPF_Contribution") {
            if (this.state.cpfContributionLocalCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.cpfContributionLocalCount + 1
                  }`;
                uploadFile.storagePath =
                  "SLOTSMemberPDFs\\Latest6MonthsCPFcontribution";
                this.setState({ is6MonCPFLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null) {

                    if (response.isNotCurrupted === true) {

                      let detail = { ...this.state.SLOTSApplicationDetails };
                      detail["latest6monthsCPFContribution"] = response.fileName;
                      detail.fileList2.push(response.fileName);
                      this.setState({
                        cpfContributionLocalCount:
                          this.state.cpfContributionLocalCount + 1,
                      });
                      this.setState({
                        SLOTSApplicationDetails: detail,
                        cPFcontributionFiles: detail.fileList2.map((p) => ({ path: p })),
                      },
                        // () =>
                        //   this.validateSLOTSMember(
                        //     "latest6monthsCPFContribution",
                        //     this.state.SLOTSApplicationDetails
                        //   )
                      );
                      this.saveSLOTsDocuments(
                        "Latest6monthsCPFContribution",
                        "latest6monthsCPFContribution",
                        "Organisation_Profile"
                      );
                    }
                    else {
                      this.swalServices.Error("Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ is6MonCPFLoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          } else if (fileType === "CPF_Complete_Contribution") {

            if (this.state.copyofcpfContributionLocalCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.copyofcpfContributionLocalCount + 1
                  }`;
                uploadFile.storagePath =
                  "SLOTSMemberPDFs\\CopyOfCPFContributionsOfCompletedProjects";
                this.setState({ isCPFConLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {

                  if (response !== null) {
                    if (response.isNotCurrupted === true) {
                      let detail = { ...this.state.SLOTSApplicationDetails };
                      detail["copyOfCPFContributionsOfCompletedProjects"] =
                        response.fileName;
                      detail.fileListOfcopyofcpfContribution.push(
                        response.fileName
                      );
                      this.setState({
                        copyofcpfContributionLocalCount:
                          this.state.copyofcpfContributionLocalCount + 1,
                      });
                      this.setState({
                        SLOTSApplicationDetails: detail,
                        copyOfCPFContributionsOfCompletedProjectsList: detail.fileListOfcopyofcpfContribution.map((p) => ({ path: p })),
                      },
                        //  () =>
                        //   this.validateSLOTSMember(
                        //     "fileListOfcopyofcpfContribution",
                        //     this.state.SLOTSApplicationDetails
                        //   )
                      );
                      this.saveSLOTsDocuments(
                        "CopyOfCPFContributionsOfCompletedProjects",
                        "copyOfCPFContributionsOfCompletedProjects",
                        "Organisation_Profile"
                      );
                    }
                    else {
                      this.swalServices.Error(" Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isCPFConLoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          } else if (fileType === "Approved_technical_qualification") {
            if (this.state.approvedTechnicalQualificationCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.approvedTechnicalQualificationCount + 1
                  }`;
                uploadFile.storagePath =
                  "SLOTSMemberPDFs\\ApprovedTechnicalQualification";
                this.setState({ isApprovedBCALoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null) {
                    if (response.isNotCurrupted === true) {


                      var detail = { ...this.state.SLOTSApplicationDetails };
                      detail["approvedTechnicalQualification"] = response.fileName;
                      detail.fileListOfApprovedTechnicalQualification.push(
                        response.fileName
                      );

                      this.setState({
                        approvedTechnicalQualificationCount:
                          this.state.approvedTechnicalQualificationCount + 1,
                      });
                      this.setState({
                        SLOTSApplicationDetails: detail
                        , approvedTechnicalQualificationList: detail.fileListOfApprovedTechnicalQualification.map((p) => ({ path: p }))
                      },
                        // () =>
                        //   this.validateSLOTSMember(
                        //     "approvedTechnicalQualification",
                        //     this.state.SLOTSApplicationDetails
                        //   )
                      );
                      this.saveSLOTsDocuments(
                        "ApprovedTechnicalQualification",
                        "approvedTechnicalQualification",
                        "Organisation_Profile"
                      );

                    }
                    else {
                      this.swalServices.Error("Invalid Document");
                    }
                  }
                  else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isApprovedBCALoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          } else if (fileType === "Bank_Account_Statement") {
            if (this.state.companyBankAccStatementCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.storagePath = "SLOTSMemberPDFs\\BankAccountStatements";
                this.setState({ isBankAccStatLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null) {
                    if (response.isNotCurrupted === true) {
                      var detail = { ...this.state.SLOTSApplicationDetails };
                      detail["companyBankStatementsOf6Month"] = response.fileName;
                      detail.bankAccountStatementList.push(response.fileName);
                      this.setState({
                        companyBankAccStatementCount:
                          this.state.companyBankAccStatementCount + 1,
                      });
                      this.setState({
                        SLOTSApplicationDetails: detail,
                        companyBankFiles: detail.bankAccountStatementList.map((p) => ({ path: p }))
                      },
                        //  () =>
                        //   this.validateSLOTSMember(
                        //     "companyBankStatementsOf6Month",
                        //     this.state.SLOTSApplicationDetails
                        //   )
                      );
                      this.saveSLOTsDocuments(
                        "CompanyBankStatementsOf6Month",
                        "companyBankStatementsOf6Month",
                        "SLOTS_Application"
                      );

                    } else {
                      this.swalServices.Error(" Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isBankAccStatLoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB!"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          else if (fileType === "CertificateOfCompletionPath") {
            if (this.state.certificateofcompletionCount + files.length <= 10) {

              if (
                file.type === "application/pdf" ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = {
                  ...this.state.resFile,
                  filename: file.name,
                  file,
                  uploadId: `UplaodFile${this.state.certificateofcompletionCount + 1}`,
                  storagePath: "SLOTSMemberPDFs\\CertificateOfCompletion",
                };

                this.setState({ isOnGoingProLoader: true });

                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null && response.isNotCurrupted === true) {
                    let detail = this.state.projectTrackRecordsDetails;
                    if (!detail.certificateofcompletionList) {
                      detail.certificateofcompletionList = [];
                    }
                    detail.certificateofcompletionList.push(response.fileName);

                    this.setState({
                      projectTrackRecordsDetails: detail,
                      certificateofcompletionList: detail.certificateofcompletionList.map(p => ({ path: p })),
                      certificateofcompletionCount: this.state.certificateofcompletionCount + 1,
                    });
                  } else {
                    this.swalServices.Error("Invalid Document");
                  }
                  this.setState({ isOnGoingProLoader: false });
                });
              } else {
                this.swalServices.Error("Invalid file type.");
              }

            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          else if (fileType === "FinalInvoiceFilePath") {
            if (this.state.finalInvoiceFileCount + files.length <= 10) {

              if (
                file.type === "application/pdf" ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = {
                  ...this.state.resFile,
                  filename: file.name,
                  file,
                  uploadId: `UplaodFile${this.state.finalInvoiceFileCount + 1}`,
                  storagePath: "SLOTSMemberPDFs\\FinalInvoiceFile",
                };

                this.setState({ isOnGoingProLoader: true });

                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null && response.isNotCurrupted === true) {
                    let detail = this.state.projectTrackRecordsDetails;
                    detail.finalInvoiceFilePathList.push(response.fileName);

                    this.setState({
                      projectTrackRecordsDetails: detail,
                      finalInvoiceFilePathList: detail.finalInvoiceFilePathList.map(p => ({ path: p })),
                      finalInvoiceFileCount: this.state.finalInvoiceFileCount + 1,
                    });
                  } else {
                    this.swalServices.Error("Invalid Document");
                  }
                  this.setState({ isOnGoingProLoader: false });
                });
              } else {
                this.swalServices.Error("Invalid file type.");
              }

            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          else if (fileType === "Letter_of_Award_or_Purchase") {
            if (this.state.LetterofAwardorPurchaseCount + files.length <= 10) {

              if (
                file.type === "application/pdf" ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.type === 'application/vnd.ms-excel' ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = {
                  ...this.state.resFile,
                  filename: file.name,
                  file,
                  uploadId: `UplaodFile${this.state.LetterofAwardorPurchaseCount + 1}`,
                  storagePath: "SLOTSMemberPDFs\\Award_PurchaseOrder_Docs",
                };

                this.setState({ isOnGoingProLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {

                  if (response !== null && response.isNotCurrupted === true) {
                    let detail = this.state.projectTrackRecordsDetails;
                    detail.letterofAwardorPurchaseOrderList.push(response.fileName);

                    this.setState({
                      projectTrackRecordsDetails: detail,
                      letterofAwardorPurchaseOrderList: detail.letterofAwardorPurchaseOrderList.map(p => ({ path: p })),
                      LetterofAwardorPurchaseCount: this.state.LetterofAwardorPurchaseCount + 1,
                    });
                  } else {
                    this.swalServices.Error("Invalid Document");
                  }
                  this.setState({ isOnGoingProLoader: false });
                });
              } else {
                this.swalServices.Error("Invalid file type.");
              }

            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          // else if (fileType === "Certificate_of_Completion") {
          //   if (this.state.supportingDocOngoingFileUploadCount < 5) {
          //     if (
          //       (file && file.type === "application/pdf") ||
          //       file.type ===
          //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          //       file.type ===
          //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          //       file.type === "application/msword" ||
          //       file.type === "application/msexcel"
          //     ) {
          //       let uploadFile = { ...this.state.resFile };
          //       uploadFile.filename = file.name;
          //       uploadFile["file"] = file;
          //       uploadFile.uploadId = `UplaodFile${this.state.certificateofcompletionCount + 1
          //         }`;
          //       uploadFile.storagePath =
          //         "SLOTSMemberPDFs\\supportingDocFormAOngoing";
          //       this.setState({ isOnGoingProLoader2: true });
          //       this.slotMemberService.uploadPDF(uploadFile).then((response) => {
          //         if (response !== null) {
          //           if (response.isNotCurrupted === true) {
          //             var detail = this.state.SLOTSApplicationDetails;

          //             detail["supportingDocFormAOngoing"] = response.fileName;
          //             detail.formAOnGoingList.push(response.fileName);
          //             this.setState(
          //               {
          //                 supportingDocFormAOngoingList: detail.formAOnGoingList.map((p) => ({ path: p })),
          //                 LOTSApplicationDetails: detail,
          //                 certificateofcompletionCount: this.state.certificateofcompletionCount + 1,
          //               },
          //               // () =>
          //               //   this.validateSLOTSMember(
          //               //     "supportingDocFormAOngoing",
          //               //     this.state.SLOTSApplicationDetails
          //               //   )
          //             );
          //             this.saveSLOTsDocuments(
          //               "SupportingDocFormAOngoing",
          //               null,
          //               null
          //             );
          //           } else {
          //             this.swalServices.Error("Invalid Document");
          //           }
          //         } else {
          //           this.swalServices.Error(response.message);
          //         }
          //         this.setState({ isOnGoingProLoader2: false });
          //       });

          //     } else {
          //       this.swalServices.Error(
          //         "Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
          //       );
          //     }
          //   } else {
          //     this.swalServices.Warning("You cannot upload more than 5 files");
          //   }
          // }
          else if (fileType === "Final_payment_or_Transfer_slip") {
            if (this.state.supportingDocCompleteFileUploadCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.supportingDocCompleteFileUploadCount + 1
                  }`;
                uploadFile.storagePath =
                  "SLOTSMemberPDFs\\supportingDocFormAOnComplete";
                this.setState({ isCompProLoader2: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null) {
                    if (response.isNotCurrupted === true) {
                      let detail = this.state.SLOTSApplicationDetails;
                      detail["supportingDocFormAOnComplete"] = response.fileName;
                      detail.formACompletedList.push(response.fileName);
                      this.setState({
                        supportingDocFormAOnCompleteList: detail.formACompletedList.map((p) => ({ path: p })),
                        supportingDocCompleteFileUploadCount:
                          this.state.supportingDocCompleteFileUploadCount + 1,
                      });
                      this.setState({ SLOTSApplicationDetails: detail },
                        // () =>
                        // this.validateSLOTSMember(
                        //   "supportingDocFormAOnComplete",
                        //   this.state.SLOTSApplicationDetails
                        // )
                      );
                      this.saveSLOTsDocuments(
                        "SupportingDocFormAOnComplete",
                        null,
                        null
                      );
                    } else {
                      this.swalServices.Error("Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isCompProLoader2: false });
                });
              } else {
                this.swalServices.Error(
                  "Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            } else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }
          }
          else if (fileType === "Upload_from_B") {
            if (this.state.completedProjectFileUploadCount < 10) {
              if (
                (file && file.type === "application/pdf") ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel"
              ) {
                let uploadFile = { ...this.state.resFile };
                uploadFile.filename = file.name;
                uploadFile["file"] = file;
                uploadFile.uploadId = `UplaodFile${this.state.completedProjectFileUploadCount + 1
                  }`;
                uploadFile.storagePath =
                  "SLOTSMemberPDFs\\ProjectTrackRecordsOfOnCompletedProject";
                this.setState({ isCompProLoader: true });
                this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                  if (response !== null) {
                    if (response.isNotCurrupted === true) {
                      var detail = this.state.SLOTSApplicationDetails;
                      detail["projectTrackRecordsOfCompletedProject"] = response.fileName;
                      detail.projectTrackRecordsOfCompletedList.push(response.fileName);
                      this.setState(
                        {
                          projectTrackCompletedProjectList: detail.projectTrackRecordsOfCompletedList.map((p) => ({ path: p })),
                          SLOTSApplicationDetails: detail,
                          completedProjectFileUploadCount: this.state.completedProjectFileUploadCount + 1,
                        },
                        // () =>
                        //   this.validateSLOTSMember(
                        //     "projectTrackRecordsOfCompletedProject",
                        //     this.state.SLOTSApplicationDetails
                        //   )
                      );
                      this.saveSLOTsDocuments(
                        "ProjectTrackRecordsOfCompletedProject",
                        "projectTrackRecordsOfCompletedProject",
                        "SLOTS_Application"
                      );
                    } else {
                      this.swalServices.Error("Invalid Document");
                    }
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isCompProLoader: false });
                });
              } else {
                this.swalServices.Error(
                  "Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
                );
              }
            }
            else {
              this.swalServices.Warning("You cannot upload more than 10 files");
            }

          } else if (fileType === "Upload_ACRA_Certificate") {
            if (
              (file && file.type === "application/pdf") ||
              file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              file.type ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              file.type === "application/msword" ||
              file.type === "application/msexcel"
            ) {
              let uploadFile = { ...this.state.resFile };
              uploadFile.filename = file.name;
              uploadFile["file"] = file;
              uploadFile.storagePath = "SLOTSMemberPDFs\\ACRACertificates";
              uploadFile.slotsMemberId =
                this.state.SLOTSApplicationDetails.slotsMemberId;
              this.setState({ isACRACerLoader: true });
              this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                if (response != null) {
                  if (response.isNotCurrupted === true) {
                    let detail = this.state.SLOTSApplicationDetails;
                    detail.uploadACRACertificate = response.fileName;
                    this.setState({ SLOTSApplicationDetails: detail },
                      //() =>
                      // this.validateSLOTSMember(
                      //   "uploadACRACertificate",
                      //   this.state.SLOTSApplicationDetails
                      // )
                    );
                    this.saveSLOTsDocuments(
                      "UploadACRACertificate",
                      "uploadACRACertificate",
                      "Organisation_Profile"
                    );
                  } else {
                    this.swalServices.Error("Invalid document");
                  }
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isACRACerLoader: false });
              });
            } else {
              this.swalServices.Error(
                "Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !"
              );
            }
          } else if (fileType === "Upload_Payment_Proof") {

            if (
              file &&
              (file.type === "image/jpeg" || file.type === "image/png")
            ) {
              let request = {};
              request.storagePath = "PaymentImages";
              request.file = file;
              request.fileName = file.name;
              this.setState({ isPaymentProofLoader: true });
              this.slotMemberService.uploadPDF(request).then((response) => {
                if (response !== null) {
                  let detail = { ...this.state.SLOTSApplicationDetails };
                  detail.uploadPaymentProof = response.fileName;
                  this.setState({ SLOTSApplicationDetails: detail },
                    // () =>
                    // this.validateSLOTSMember(
                    //   "uploadPaymentProof",
                    //   this.state.SLOTSApplicationDetails
                    // )
                  );
                  this.saveSLOTsDocuments(
                    "UploadPaymentProof",
                    "uploadPaymentProof",
                    "SLOTS_Application"
                  );
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isPaymentProofLoader: false });
              });
            } else {
              this.swalServices.Error("Please select only Image");
            }
          } else if (fileType === "WorkshopProofPath" || fileType === "IAOOrbizSAFEStar" || fileType === "ISOOrGreenPolicy" || fileType === "AppointmentletterforSGSecure") {
            if ((file && file.type === "application/pdf") || (file.type === "image/jpeg") || (file.type === "image/jpg") || (file.type === "image/png")) {
              let request = {};
              request.storagePath = "UploadWorkshopProof";
              request.file = file;
              request.fileName = file.name;
              this.setState({ isPaymentProofLoader: true });
              this.slotMemberService.uploadPDF(request).then((response) => {
                if (response != null) {
                  let detail = { ...this.state.SLOTSApplicationDetails };

                  if (fileType === 'WorkshopProofPath') {
                    detail.workshopProofPath = response.fileName;
                  } else if (fileType === 'IAOOrbizSAFEStar') {
                    detail.iaoOrbizSAFEStar = response.fileName;
                  } else if (fileType === 'ISOOrGreenPolicy') {
                    detail.isoOrGreenPolicy = response.fileName;
                  } else if (fileType === 'AppointmentletterforSGSecure') {
                    detail.appointmentletterforSGSecure = response.fileName;
                  }
                  this.setState({ SLOTSApplicationDetails: detail }, () =>
                    this.saveSLOTsDocuments(fileType)
                  );
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isPaymentProofLoader: false });
              });
            } else {
              this.swalServices.Error("Please Upload Image or PDF files only");
            }
          } else if (fileType === "Upload_from_A_For_Renewal") {
            if (file.size < 5242880) {
              if (this.state.formACount < 10) {
                if (
                  (file && file.type === "application/pdf") ||
                  (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
                  (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
                  (file.type === "application/msword") ||
                  (file.type === "application/msexcel")
                ) {
                  let uploadFile = { ...this.state.resFile };
                  uploadFile.filename = file.name;
                  uploadFile["file"] = file;
                  uploadFile.uploadId = `UplaodFile${this.state.formACount + 1}`;
                  uploadFile.storagePath = "SLOTSMemberPDFs\\FormA";
                  this.setState({ isformALoader: true });
                  this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                    if (response != null) {
                      if (response.isNotCurrupted === true) {
                        let detail = this.state.SLOTSApplicationDetails;
                        detail.formAList.push(response.fileName);
                        this.setState({ formACount: this.state.formACount + 1 });
                        this.setState({ slotsApplicationDetail: detail },
                          () => {
                            this.saveSLOTsDocuments('formA', "formA", "SLOTS_ApplicationIsRenewal");
                          });
                      }
                      else {
                        this.swalServices.Error("Invalid document");
                      }
                    }
                    else {
                      this.swalServices.Error(response.message);
                    }
                    this.setState({ isformALoader: false });
                  })
                }
                else {
                  this.swalServices.Error("Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !");
                }
              }
              else {
                this.swalServices.Warning("You cannot upload more than 10 files");
              }
            }
            else {
              this.swalServices.Error("File size must be less than 5 MB!");
            }
          }
          else if (fileType === "supportingDocFormA") {
            if (file.size < 5242880) {
              if (this.state.supportingDocFormACount < 10) {
                if (
                  (file && file.type === "application/pdf") ||
                  (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
                  (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
                  (file.type === "application/msword") ||
                  (file.type === "application/msexcel")
                ) {
                  let uploadFile = { ...this.state.resFile };
                  uploadFile.filename = file.name;
                  uploadFile["file"] = file;
                  uploadFile.uploadId = `UplaodFile${this.state.supportingDocFormACount + 1}`;
                  uploadFile.storagePath = "SLOTSMemberPDFs\\SupportingDocFormA";
                  this.setState({ isFormASupportingDocumentLoader: true });
                  this.slotMemberService.uploadPDF(uploadFile).then((response) => {

                    console.log("File upload response OnGoing:", response);
                    if (response != null) {
                      if (response.isNotCurrupted === true) {
                        let detail = this.state.SLOTSApplicationDetails;
                        detail.supportingDocFormAList.push(response.fileName);
                        this.setState({ supportingDocFormACount: this.state.supportingDocFormACount + 1 });
                        this.setState({ slotsApplicationDetail: detail },
                          () => {
                            this.saveSLOTsDocuments('supportingDocFormA', 'supportingDocFormA', 'SLOTS_ApplicationIsRenewal');
                          });
                      }
                      else {
                        this.swalServices.Error("Invalid document");
                      }


                    }
                    else {
                      this.swalServices.Error(response.message);
                    }
                    this.setState({ isFormASupportingDocumentLoader: false });
                  })
                }
                else {
                  this.swalServices.Error("Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !");
                }
              }
              else {
                this.swalServices.Warning("You cannot upload more than 10 files");
              }
            } else {
              this.swalServices.Error("File size must be less than 5 MB!");
            }
          }
          else if (fileType === "Certificate_of_Attendance") {
            if (
              (file && file.type === "application/pdf") ||
              (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
              (file.type === "application/msword") ||
              (file.type === "application/msexcel")
            ) {
              let uploadFile = { ...this.state.resFile };
              uploadFile.filename = file.name;
              uploadFile["file"] = file;
              uploadFile.storagePath = "SLOTSMemberPDFs\\Certificate_of_Attendance";
              this.slotMemberService.uploadPDF(uploadFile).then((response) => {
                if (response != null) {
                  let detail = this.state.SLOTSApplicationDetails;
                  detail.certificateofAttendance = response.fileName;
                  this.setState({ SLOTSApplicationDetails: detail },
                    () => {
                      this.saveSLOTsDocuments('CertificateofAttendance', 'certificate_of_Attendance', 'SLOTS_ApplicationIsRenewal');
                    });
                }
                else {
                  this.swalServices.Error(response.message);
                }
              })
            }
            else {
              this.swalServices.Error("Please Upload only PDF, DOC, DOCX, XLS, XLSX files & Max of 5MB !");
            }
          }
        } else {
          this.swalServices.Error("File size must be less than 5 MB!");
        }
      }
    } else {

      this.swalServices
        .ErrorWithAction("Please login for upload documents!", "OK")
        .then((res) => {
        });
    }
  };



  // Save SLOTS documents path to database method

  saveSLOTsDocuments = (fileType, validationFieldName, SelectName) => {

    if (this.state.slotsMemberId > 0) {
      let request = {};
      request.columnName = fileType;
      request.slotsMemberId = this.state.slotsMemberId;
      request.fileName = "";
      if (fileType === "UploadACRACertificate") {
        request.fileName =
          this.state.SLOTSApplicationDetails.uploadACRACertificate;
      } else if (fileType === "UploadWPOnlineRecord") {
        if (this.state.SLOTSApplicationDetails.fileListOfWPRecord.length > 0) {
          request.fileName = "";
          var arr1 = this.state.SLOTSApplicationDetails.fileListOfWPRecord.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        }
      } else if (fileType === 'UploadCorporatebankRecords') {
        if (this.state.SLOTSApplicationDetails.fileListCorporatebankRecords.length > 0) {
          request.fileName = ''
          let arr1 = this.state.SLOTSApplicationDetails.fileListCorporatebankRecords.map(function (value) {
            return value;
          });
          request.fileName = arr1.join([","]);
        }
      }

      else if (fileType === "Latest6monthsCPFContribution") {
        if (this.state.SLOTSApplicationDetails.fileList2.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.fileList2.map(function (
            value
          ) {
            return value;
          });
          request.fileName = arr1.join([","]);
        }
      } else if (fileType === "CopyOfCPFContributionsOfCompletedProjects") {
        if (
          this.state.SLOTSApplicationDetails.fileListOfcopyofcpfContribution
            .length > 0
        ) {
          request.fileName = "";
          let arr1 =
            this.state.SLOTSApplicationDetails.fileListOfcopyofcpfContribution.map(
              function (value) {
                return value;
              }
            );
          request.fileName = arr1.join([","]);
        }
      } else if (fileType === "ApprovedTechnicalQualification") {
        if (
          this.state.SLOTSApplicationDetails
            .fileListOfApprovedTechnicalQualification.length > 0
        ) {
          request.fileName = "";
          let arr1 =
            this.state.SLOTSApplicationDetails.fileListOfApprovedTechnicalQualification.map(
              function (value) {
                return value;
              }
            );
          request.fileName = arr1.join([","]);
        }
      } else if (fileType === "CompanyBankStatementsOf6Month") {
        if (
          this.state.SLOTSApplicationDetails.bankAccountStatementList.length > 0
        ) {
          request.fileName = "";
          let arr1 =
            this.state.SLOTSApplicationDetails.bankAccountStatementList.map(
              function (value) {
                return value;
              }
            );
          request.fileName = arr1.join([","]);
        }
      }
      //else if (fileType === "ProjectTrackRecordsOfOnGoingProject") {      
      //   request.fileName =
      //     this.state.SLOTSApplicationDetails.projectTrackRecordsOfOnGoingProject;

      // } 
      else if (fileType === "ProjectTrackRecordsOfOnGoingProject") {
        if (this.state.SLOTSApplicationDetails.formAOnGoingProjectList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.formAOnGoingProjectList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }

      else if (fileType === "ProjectTrackRecordsOfCompletedProject") {
        // request.fileName =
        //   this.state.SLOTSApplicationDetails.projectTrackRecordsOfCompletedProject;

        if (this.state.SLOTSApplicationDetails.projectTrackRecordsOfCompletedList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.projectTrackRecordsOfCompletedList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      } else if (fileType === "SupportingDocFormAOngoing") {
        if (this.state.SLOTSApplicationDetails.formAOnGoingList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.formAOnGoingList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      } else if (fileType === "SupportingDocFormAOnComplete") {
        if (this.state.SLOTSApplicationDetails.formACompletedList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.formACompletedList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      } else if (fileType === "UploadPaymentProof") {
        request.fileName =
          this.state.SLOTSApplicationDetails.uploadPaymentProof;
      } else if (fileType === "WorkshopProofPath") {
        request.fileName =
          this.state.SLOTSApplicationDetails.workshopProofPath;
      } else if (fileType === "IAOOrbizSAFEStar") {
        request.fileName = this.state.SLOTSApplicationDetails.iaoOrbizSAFEStar;
      } else if (fileType === "ISOOrGreenPolicy") {
        request.fileName = this.state.SLOTSApplicationDetails.isoOrGreenPolicy;
      } else if (fileType === "AppointmentletterforSGSecure") {
        request.fileName = this.state.SLOTSApplicationDetails.appointmentletterforSGSecure;
      } else if (fileType === "supportingDocFormA") {
        if (this.state.SLOTSApplicationDetails.supportingDocFormAList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.supportingDocFormAList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }
      else if (fileType === "FinalInvoiceFilePath") {
        if (this.state.projectTrackRecordsDetails.finalInvoiceFilePathList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.projectTrackRecordsDetails.finalInvoiceFilePathList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }
      else if (fileType === "Letter_of_Award_or_Purchase") {
        if (this.state.projectTrackRecordsDetails.letterofAwardorPurchaseOrderList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.projectTrackRecordsDetails.letterofAwardorPurchaseOrderList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }
      else if (fileType === 'CertificateOfCompletionPath') {
        if (this.state.projectTrackRecordsDetails.certificateofcompletionList.length > 0) {
          request.fileName = "";
          let arr1 = this.state.projectTrackRecordsDetails.certificateofcompletionList.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }
      else if (fileType === 'Upload_corporate_bank_Record') {
        if (this.state.SLOTSApplicationDetails.fileListCorporatebankRecords.length > 0) {
          request.fileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.fileListCorporatebankRecords.map(
            function (value) {
              return value;
            }
          );
          request.fileName = arr1.join([","]);
        } else {
          request.fileName = "";
        }
      }
      else if (fileType === "CertificateofAttendance") {
        request.fileName = this.state.SLOTSApplicationDetails.certificateofAttendance;
      }
      this.slotMemberService.saveSLOTsDocuments(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success("File Uploaded");
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isACRACerLoader: false });
      });
    }
  };


  // Delete SLOTs member file method
  deleteSlotsMembersFiles = (fileName, fileType, slotsMemberId) => {

    if (slotsMemberId > 0) {
      const isOngoing = fileType === "Upload_letter_of_award_Ongoing" ||
        fileType === "Upload_final_invoice_Ongoing";

      const projectId = isOngoing
        ? this.state.projectTrackRecordsDetails.ongoingProjectID
        : this.state.projectTrackRecordsDetails.completedProjectID;

      const request = {
        SLOTSMemberId: slotsMemberId,
        SlotsFileType: fileType,
        SlotsFileName: fileName, // you're clearing the file list in SQL
        ProjectId: projectId  // ✅ Pass this to target correct project row

      };
      if (fileType === "WPOnlineRecord") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "UploadWPOnlineRecord",
                "uploadWPOnlineRecord",
                "Organisation_Profile"
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "Latest6monthsCPF") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "Latest6monthsCPFContribution",
                "latest6monthsCPFContribution",
                "Organisation_Profile"
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "CopyOfCPF") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "CopyOfCPFContributionsOfCompletedProjects",
                "copyOfCPFContributionsOfCompletedProjects",
                "Organisation_Profile"
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "ApprovedTechnicalQualification") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "ApprovedTechnicalQualification",
                "approvedTechnicalQualification",
                "Organisation_Profile"
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "BankStatementsOf6Month ") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "CompanyBankStatementsOf6Month",
                "companyBankStatementsOf6Month",
                "SLOTS_Application"
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "SupportingFormAOngoing") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments("SupportingDocFormAOngoing", null, null);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      } else if (fileType === "SupportingFormAOnComplete") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments(
                "SupportingDocFormAOnComplete",
                null,
                null
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      }
      else if (fileType === "OnGoingProject") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments("ProjectTrackRecordsOfOnGoingProject", null, null);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      }
      else if (fileType === "ProjectTrackRecordsOfCompleted") {
        this.slotMemberService
          .deleteSlotsMembersFiles(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.setState({ fileDeletedFlag: true });
              this.saveSLOTsDocuments("ProjectTrackRecordsOfCompletedProject", null, null);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isWPRecordLoader: false });
          });
      }
      else if (fileType === "Upload_letter_of_award_Ongoing" || fileType === "Upload_letter_of_award_Completed") {
        this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
          if (response != null && response.statusCode === 200) {
            this.setState((prevState) => ({
              fileDeletedFlag: true,
              LetterofAwardorPurchaseCount: prevState.LetterofAwardorPurchaseCount - 1
            }));
            let detail = this.state.projectTrackRecordsDetails;
            this.setState({ projectTrackRecordsDetails: detail });

            this.saveProjectTrackRecordDocuments(fileType, null, null);
          } else {
            this.swalServices.Error(response.message);
          }
          //this.setState({ isWPRecordLoader: false });
        });
      }
      else if (fileType === "Upload_final_invoice_Ongoing" || fileType === "Upload_final_invoice_Completed") {
        this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
          if (response != null && response.statusCode === 200) {
            this.setState((prevState) => ({
              fileDeletedFlag: true,
              finalInvoiceFileCount: prevState.finalInvoiceFileCount - 1
            }));
            let detail = this.state.projectTrackRecordsDetails;
            this.setState({ projectTrackRecordsDetails: detail });

            this.saveProjectTrackRecordDocuments(fileType, null, null);
          } else {
            this.swalServices.Error(response.message);
          }
          //this.setState({ isWPRecordLoader: false });
        });
      }
      else if (fileType === "Upload_certificate_of_completion") {
        this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
          if (response != null && response.statusCode === 200) {
            this.setState((prevState) => ({
              fileDeletedFlag: true,
              certificateofcompletionCount: prevState.certificateofcompletionCount - 1
            }));
            let detail = this.state.projectTrackRecordsDetails;
            this.setState({ projectTrackRecordsDetails: detail });

            this.saveProjectTrackRecordDocuments(fileType, null, null);
          } else {
            this.swalServices.Error(response.message);
          }
          //this.setState({ isWPRecordLoader: false });
        });
      }
    }
  };
  saveProjectTrackRecordDocuments = (fileType, validationFieldName, SelectName) => {

    if (this.state.slotsMemberId > 0) {
      let request = {
        columnName: fileType,
        projectId: 0,
        fileName: '',
        isOnGoing: false,
        isCompleted: false
      };

      // Handle letter of award uploads
      if (fileType === "Upload_letter_of_award_Ongoing" || fileType === "Upload_letter_of_award_Completed") {
        const list = this.state.projectTrackRecordsDetails.letterofAwardorPurchaseOrderList || [];

        request.columnName = 'LetterofAwardorPurchaseOrderDocs';
        request.fileName = list.map(item => item?.path || item).join(',');
        request.isOnGoing = fileType === "Upload_letter_of_award_Ongoing";
        request.isCompleted = fileType === "Upload_letter_of_award_Completed";
        request.projectId = request.isOnGoing
          ? this.state.projectTrackRecordsDetails.ongoingProjectID
          : this.state.projectTrackRecordsDetails.completedProjectID;
      }
      else if (fileType === "Upload_final_invoice_Ongoing" || fileType === "Upload_final_invoice_Completed") {
        const list = this.state.projectTrackRecordsDetails.finalInvoiceFilePathList || [];
        request.columnName = 'FinalInvoiceFilePath';
        request.fileName = list.map(item => item?.path || item).join(',');
        request.isOnGoing = fileType === "Upload_final_invoice_Ongoing";
        request.isCompleted = fileType === "Upload_final_invoice_Completed";
        request.projectId = request.isOnGoing
          ? this.state.projectTrackRecordsDetails.ongoingProjectID
          : this.state.projectTrackRecordsDetails.completedProjectID;
      }
      else if (fileType === "Upload_certificate_of_completion") {
        const list = this.state.projectTrackRecordsDetails.certificateofcompletionList || [];
        request.columnName = 'CertificateOfCompletionPath';
        request.fileName = list.map(item => item?.path || item).join(',');
        request.isCompleted = this.state.projectTrackRecordsDetails.isCompleted;
        request.projectId = this.state.projectTrackRecordsDetails.completedProjectID;
      }

      this.slotMemberService.SaveSLOTsProjectTrackRecordDocuments(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem) {
          if (this.state.fileDeletedFlag === true) {
            this.swalServices.Success("File Deleted");
            this.setState({ fileDeletedFlag: false });
          }
          else {
            this.swalServices.Success("File Uploaded");
          }
          if (validationFieldName && SelectName) {
            this.validateField(validationFieldName, SelectName);
          }
        } else {
          this.swalServices.Error(response.message);
        }

        this.setState({ isACRACerLoader: false });
      });
    }
  };
  // Delete uploaded file from array
  deleteFile = (value, identity) => {

    if (identity === "ACRA_Certificates") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["fileList"].splice(find, 1);
      }
      this.setState({ SLOTSApplicationDetails: det });
    }
    else if (identity === "Upload_corporate_bank_Record") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileListCorporatebankRecords"].findIndex((x) => x === value);
      if (find >= 0) {
        det["fileListCorporatebankRecords"].splice(find, 1);
        this.setState({ corporatebankRecordCount: this.state.corporatebankRecordCount - 1 });
        this.deleteSlotsMembersFiles(value, "CorporatebankRecords", this.state.slotsMemberId);
      }
      this.setState({ SLOTSApplicationDetails: det })
    }
    // else if (identity === "Upload_Certificate_Of_Completion") {
    //   let det = this.state.SLOTSApplicationDetails;
    //   let find = det["fileListCertificateOfCompletion"].findIndex((x) => x === value);
    //   if (find >= 0) {
    //     det["fileListCertificateOfCompletion"].splice(find, 1);
    //     this.setState({ certificateofcompletionCount: this.state.certificateofcompletionCount - 1 });
    //     this.deleteSlotsMembersFiles(value, "CertificateOfCompletion", this.state.slotsMemberId);
    //   }
    //   this.setState({ SLOTSApplicationDetails: det })
    // }
    else if (identity === "CPF_Contribution") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileList2"].findIndex((x) => x === value);
      if (find >= 0) {
        det["fileList2"].splice(find, 1);
        this.setState({
          cpfContributionLocalCount: this.state.cpfContributionLocalCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "Latest6monthsCPF",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "CPF_Complete_Contribution") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileListOfcopyofcpfContribution"].findIndex(
        (x) => x === value
      );
      if (find >= 0) {
        det["fileListOfcopyofcpfContribution"].splice(find, 1);
        this.setState({
          copyofcpfContributionLocalCount:
            this.state.copyofcpfContributionLocalCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "CopyOfCPF",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "Approved_technical_qualification") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileListOfApprovedTechnicalQualification"].findIndex(
        (x) => x === value
      );
      if (find >= 0) {
        det["fileListOfApprovedTechnicalQualification"].splice(find, 1);
        this.setState({
          approvedTechnicalQualificationCount:
            this.state.approvedTechnicalQualificationCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "ApprovedTechnicalQualification",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "Upload_WP_Record") {

      let det = this.state.SLOTSApplicationDetails;
      let find = det["fileListOfWPRecord"].findIndex((x) => x === value);
      if (find >= 0) {
        det["fileListOfWPRecord"].splice(find, 1);
        this.setState({
          wPOnlineRecordCount: this.state.wPOnlineRecordCount - 1,
        });
      }
      this.setState({ SLOTSApplicationDetails: det });
      this.deleteSlotsMembersFiles(
        value,
        "WPOnlineRecord",
        this.state.SLOTSApplicationDetails.slotsMemberId
      );
    } else if (identity === "Bank_Account_Statement_6Months") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["bankAccountStatementList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["bankAccountStatementList"].splice(find, 1);
        this.setState({
          companyBankAccStatementCount:
            this.state.companyBankAccStatementCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "BankStatementsOf6Month ",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "Supporting_Doc_Form_Ongoing") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["formAOnGoingList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["formAOnGoingList"].splice(find, 1);
        this.setState({
          supportingDocOngoingFileUploadCount:
            this.state.supportingDocOngoingFileUploadCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "SupportingFormAOngoing",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "ProjectTrack_RecordsOfOn_GoingProject") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["formAOnGoingProjectList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["formAOnGoingProjectList"].splice(find, 1);
        this.setState({
          onGoingProjectFileUploadCount:
            this.state.onGoingProjectFileUploadCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "OnGoingProject",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    } else if (identity === "project_Track_Records_Completed_Project") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["projectTrackRecordsOfCompletedList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["projectTrackRecordsOfCompletedList"].splice(find, 1);
        this.setState({
          completedProjectFileUploadCount:
            this.state.completedProjectFileUploadCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "ProjectTrackRecordsOfCompleted",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    }
    else if (identity === "Supporting_Doc_Form_Complete") {
      let det = this.state.SLOTSApplicationDetails;
      let find = det["formACompletedList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["formACompletedList"].splice(find, 1);
        this.setState({
          supportingDocCompleteFileUploadCount:
            this.state.supportingDocCompleteFileUploadCount - 1,
        });
        this.deleteSlotsMembersFiles(
          value,
          "SupportingFormAOnComplete",
          this.state.SLOTSApplicationDetails.slotsMemberId
        );
      }
      this.setState({ SLOTSApplicationDetails: det });
    }
    else if (identity === "Upload_letter_of_award_Completed" || identity === "Upload_letter_of_award_Ongoing") {

      const det = this.state.projectTrackRecordsDetails || [];
      const list = det["letterofAwardorPurchaseOrderList"] || [];

      // Check if the list contains at least one object with a 'path' key
      const hasPathObjects = Array.isArray(list) && list.some(item => item && typeof item === 'object' && 'path' in item);

      if (hasPathObjects) {
        // It's an array of objects with 'path' keys
        const findIndex = list.findIndex(item => item.path === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ LetterofAwardorPurchaseCount: this.state.LetterofAwardorPurchaseCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      } else {
        // It's a simple array of strings
        const findIndex = list.findIndex(item => item === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ LetterofAwardorPurchaseCount: this.state.LetterofAwardorPurchaseCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      }

      // Update the full object back into state
      det["letterofAwardorPurchaseOrderList"] = list;
      this.setState({ projectTrackRecordsDetails: det });
    }

    else if (identity === "Upload_final_invoice_Ongoing" || identity === "Upload_final_invoice_Completed") {


      const det = this.state.projectTrackRecordsDetails || [];
      const list = det["finalInvoiceFilePathList"] || [];

      // Check if the list contains objects with a 'path' key
      const hasPathObjects = Array.isArray(list) && list.some(item => item && typeof item === 'object' && 'path' in item);

      if (hasPathObjects) {
        const findIndex = list.findIndex(item => item.path === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ finalInvoiceFileCount: this.state.finalInvoiceFileCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      } else {
        const findIndex = list.findIndex(item => item === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ finalInvoiceFileCount: this.state.finalInvoiceFileCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      }

      // Update back into state
      det["finalInvoiceFilePathList"] = list;
      this.setState({ projectTrackRecordsDetails: det });
    }

    else if (identity === "Upload_certificate_of_completion") {


      const det = this.state.projectTrackRecordsDetails || [];
      const list = det["certificateofcompletionList"] || [];

      // Check if the list contains objects with a 'path' key
      const hasPathObjects = Array.isArray(list) && list.some(item => item && typeof item === 'object' && 'path' in item);

      if (hasPathObjects) {
        const findIndex = list.findIndex(item => item.path === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ certificateofcompletionCount: this.state.certificateofcompletionCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      } else {
        const findIndex = list.findIndex(item => item === value);
        if (findIndex >= 0) {
          list.splice(findIndex, 1);
          this.setState({ certificateofcompletionCount: this.state.certificateofcompletionCount - 1 });
          this.deleteSlotsMembersFiles(value, identity, this.state.slotsMemberId);
        }
      }

      // Update the list in the state object
      det["certificateofcompletionList"] = list;
      this.setState({ projectTrackRecordsDetails: det });
    }

  };


  getAuthorisedRepresentative = (key) => {

    let authorisedRepresentativeData = this.state.SLOTSApplicationDetails.authorisedRepresentativeSummaryList;
    let setData = authorisedRepresentativeData[key];
    let data = {};
    data.authorisedRepresentativeId = setData.authorisedRepresentativeId;
    data.roleId = setData.roleId;
    data.firstName = setData.firstName;
    data.lastName = setData.lastName;
    data.jobTitle = setData.jobTitle;
    data.directOfficeNumber = setData.directOfficeNumber;
    data.mobileNumber = setData.mobileNumber;
    data.emailAddress = setData.emailAddress;
    data.isNewsletter = setData.isNewsletter;
    data.isTelegram = setData.isTelegram;
    data.isePortal = setData.isePortal;
    data.slotsMemberId = setData.slotsMemberId;
    data.roles = this.state.roleList.filter(role => role.value === setData.roleId)[0]?.label;

    this.setState({ roleDetails: data });
  };

  getProjectTrackRecordDataToEdit = (key) => {

    let authorisedRepresentativeData = this.state.SLOTSApplicationDetails.authorisedRepresentativeSummaryList;
    let setData = authorisedRepresentativeData[key];
    let data = {};
    data.authorisedRepresentativeId = setData.authorisedRepresentativeId;
    data.roleId = setData.roleId;
    data.firstName = setData.firstName;
    data.lastName = setData.lastName;
    data.jobTitle = setData.jobTitle;
    data.directOfficeNumber = setData.directOfficeNumber;
    data.mobileNumber = setData.mobileNumber;
    data.emailAddress = setData.emailAddress;
    data.isNewsletter = setData.isNewsletter;
    data.isTelegram = setData.isTelegram;
    data.isePortal = setData.isePortal;
    data.slotsMemberId = setData.slotsMemberId;
    data.roles = this.state.roleList.filter(role => role.value === setData.roleId)[0]?.label;

    this.setState({ roleDetails: data });
  };

  addEditAuthoriseRepresentativeSummary = () => {
    const audit = getAuditContext();

    let request = this.state.roleDetails;
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;

    request.sLOTSMemberId = this.state.slotsMemberId;
    this.setState({ isRepresentativeLoader: true });
    this.slotMemberService
      .addEditAuthoriseRepresentativeSummary(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success(
            "Authorised representative summary added sucessfully!"

          );
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isRepresentativeLoader: false });
      });
  };

  // deleteSlotsMembersFilesComman = (value, identity) => {
  //   let request = {};
  //   request.sLOTSMemberId = this.state.slotsMemberId;
  //   request.slotsFileType = identity;
  //   let det = this.state.SLOTSApplicationDetails;
  //   let find = det["supportingDocFormAList"].findIndex((x) => x === value);
  //   if (find >= 0) {
  //     det["supportingDocFormAList"].splice(find, 1);
  //   }
  //   this.setState({ supportingDocFormACount: this.state.supportingDocFormACount - 1, SLOTSApplicationDetails: det }, () => {

  //     if (this.state.SLOTSApplicationDetails.supportingDocFormAList.length > 0) {
  //       request.slotsFileName = "";
  //       let arr1 = this.state.SLOTSApplicationDetails.supportingDocFormAList.map(function (value) {
  //         return value;
  //       });
  //       request.slotsFileName = arr1.join([","]);
  //     } else {
  //       request.slotsFileName = "";
  //     }
  //     this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
  //       if (response != null && response.statusCode === 200) {
  //         this.swalServices.Success("File Deleted");
  //       }
  //       else {
  //         this.swalServices.Error(response.message);
  //       }
  //     })
  //   })
  // }

  deleteSlotsMembersFilesComman = (value, identity) => {
    let request = {};
    request.sLOTSMemberId = this.state.slotsMemberId;
    request.slotsFileType = identity;
    let det = this.state.SLOTSApplicationDetails;

    if (identity === 'SupportingDocFormA') {
      let find = det["supportingDocFormAList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["supportingDocFormAList"].splice(find, 1);
      }
      this.setState({ supportingDocFormACount: this.state.supportingDocFormACount - 1, SLOTSApplicationDetails: det }, () => {

        if (this.state.SLOTSApplicationDetails.supportingDocFormAList.length > 0) {
          request.slotsFileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.supportingDocFormAList.map(function (value) {
            return value;
          });
          request.slotsFileName = arr1.join(",");
        } else {
          request.slotsFileName = "";
        }

        this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
          if (response != null && response.statusCode === 200) {
            this.swalServices.Success("File Deleted");
          }
          else {
            this.swalServices.Error(response.message);
          }
        });
      });
    } else {
      let find = det["formAList"].findIndex((x) => x === value);
      if (find >= 0) {
        det["formAList"].splice(find, 1);
      }
      this.setState({ formACount: this.state.formACount - 1, SLOTSApplicationDetails: det }, () => {

        if (this.state.SLOTSApplicationDetails.formAList.length > 0) {
          request.slotsFileName = "";
          let arr1 = this.state.SLOTSApplicationDetails.formAList.map(function (value) {
            return value;
          });
          request.slotsFileName = arr1.join(",");
        } else {
          request.slotsFileName = "";
        }

        this.slotMemberService.deleteSlotsMembersFiles(request).then((response) => {
          if (response != null && response.statusCode === 200) {
            this.swalServices.Success("File Deleted");
          }
          else {
            this.swalServices.Error(response.message);
          }
        });
      });
    }
  }

  removeSLOTSRegistrationHeadScopeTopUp = (id) => {
    this.slotMemberService
      .RemoveSLOTSRegistrationHeadScopeTopUp(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.GetRenewalSLOTsRegistrationHeadByMemberId(this.state.slotsMemberId);
          this.swalServices.Success(
            "Registration head(s)  (Top-Up) Deleted successfully"
          );

        } else {
          this.swalServices.Error(response.message);
        }
      });
  };
  removeSLOTSRegistrationHeadScopeTopUpAdditional = (id) => {
    this.slotMemberService
      .RemoveSLOTSRegistrationHeadScopeTopUpAdditional(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {

          this.pricingCalculationAdditional();
          this.swalServices.Success(
            "Registration head(s)  (Top-Up) Deleted successfully"
          );
        } else {
          this.swalServices.Error(response.message);
        }
      });
  };

  setProjectTypeFlags = ({ isOngoingProject, isCompletedProject }) => {

    this.setState({
      IsOngoing: isOngoingProject,
      IsCompleted: isCompletedProject,
    });
  };

  //price calculation
  pricingCalculation = () => {

    let IsWithNewSubscriptionPeriod = true;
    if (this.state.isWithNewSubscriptionPeriod == false || this.state.isWithNewSubscriptionPeriod == null) {
      IsWithNewSubscriptionPeriod = false;
    }

    let pricingData = this.state.priceCalculatorArray;
    this.state.SLOTSApplicationDetails.slotsRegistrationHeadScopeTopUp.forEach(
      (element) => {
        element.mainGroupId = element.selectedMainGroupId;
      }
    );

    let data =
      this.state.SLOTSApplicationDetails.slotsRegistrationHeadScopeTopUp;

    let max2GroupPrice = IsWithNewSubscriptionPeriod ?
      this.state.slotsMemberPricingDetail.slotsAnnual1To2TradeSameCategoryFee : 350;
    let additionalGroupPrice = IsWithNewSubscriptionPeriod ?
      this.state.slotsMemberPricingDetail.slotsAnnualTradeExistingCategoryFee : 50;

    //existing category
    let newPrice = data;
    newPrice.map((x) => {
      x.isCalculated = false;
      return x;
    });

    pricingData[0].quantity = 0;
    pricingData[1].quantity = 0;
    pricingData[0].Amount = 0;
    pricingData[1].Amount = 0;
    pricingData[2].Amount = 0;
    data.map((item, keyId) => {
      let price1 = newPrice.filter(
        (id) => id.mainGroupId === item.mainGroupId && id.isCalculated === false
      );
      if (price1.length > 0) {
        if (price1.length === 1 || price1.length === 2) {
          let count = 1;
          pricingData[0].Amount = pricingData[0].Amount + max2GroupPrice; //350
          pricingData[0].quantity = pricingData[0].quantity + count;

        }

        if (price1.length > 2) {
          let count = 1;

          pricingData[0].Amount = pricingData[0].Amount + max2GroupPrice; // 350
          pricingData[1].Amount =
            pricingData[1].Amount + additionalGroupPrice * (price1.length - 2); //50

          pricingData[0].quantity = pricingData[0].quantity + count;
          pricingData[1].quantity =
            pricingData[1].quantity + (price1.length - 2);
        }
        newPrice.map((x) => {
          if (item.mainGroupId === x.mainGroupId) {
            x.isCalculated = true;

          }
          return x;
        });

      }
      return item;
    });
    pricingData[2].quantity = pricingData[0].quantity + pricingData[1].quantity;
    pricingData[2].Amount = pricingData[0].Amount + pricingData[1].Amount;

    //this part temporary commented
    // pricingData[0].Amount = pricingData[0].Amount - this.state.SLOTSApplicationDetails.priceCalculator[0].amount;
    // pricingData[0].quantity = pricingData[0].quantity - this.state.SLOTSApplicationDetails.priceCalculator[0].quantity;

    // pricingData[1].Amount = pricingData[1].Amount - this.state.SLOTSApplicationDetails.priceCalculator[1].amount;
    // pricingData[1].quantity = pricingData[1].quantity - this.state.SLOTSApplicationDetails.priceCalculator[1].quantity;

    // pricingData[2].Amount = pricingData[2].Amount - this.state.SLOTSApplicationDetails.priceCalculator[2].amount;
    // pricingData[2].quantity = pricingData[2].quantity - this.state.SLOTSApplicationDetails.priceCalculator[2].quantity;

    console.log("new  data :- ", pricingData);
    this.setState({ priceCalculatorArray: pricingData });

    console.log(
      "check old price :- ",
      this.state.SLOTSApplicationDetails.priceCalculator
    );
  };
  pricingCalculationAdditional = () => {

    const max2GroupPrice =
      this.state.slotsMemberPricingDetail
        .slotsAnnual1To2TradeSameCategoryFee || 350;

    const additionalGroupPrice =
      this.state.slotsMemberPricingDetail
        .slotsAnnualTradeExistingCategoryFee || 50;


    /*
     * ---------------------------------------------------------
     * PRICE ARRAY
     * ---------------------------------------------------------
     */

    let pricingData =
      this.state.priceCalculatorArrayTopUpAdditional;

    if (!pricingData || pricingData.length < 3) {

      pricingData = [
        {
          value: 1,
          description:
            "Registration of Trade-head(s) under same category (max 2)",
          quantity: 0,
          Amount: 0
        },
        {
          value: 1,
          description:
            "Registration of additional Trade-head(s) under existing category",
          quantity: 0,
          Amount: 0
        },
        {
          value: 3,
          description:
            "Subtotal (before GST)",
          quantity: 0,
          Amount: 0
        }
      ];

    } else {

      pricingData =
        pricingData.map((item) => ({
          ...item,
          quantity: 0,
          Amount: 0
        }));
    }


    /*
     * ---------------------------------------------------------
     * EXISTING TOP-UP HEADS
     * ---------------------------------------------------------
     */

    const oldScopes =
      this.state.SLOTSApplicationDetails
        .slotsRegistrationHeadScopeTopUp || [];


    /*
     * NEW TOP-UP HEADS
     * ---------------------------------------------------------
     */

    const newScopes =
      this.state.SLOTSApplicationDetails
        .slotsRegistrationHeadScopeTopUpAdditional || [];


    /*
     * ---------------------------------------------------------
     * GROUP EXISTING HEADS
     * ---------------------------------------------------------
     */

    const oldGroupCounts = {};

    oldScopes.forEach((item) => {

      const mainGroupId =
        item.selectedMainGroupId ||
        item.mainGroupId;

      oldGroupCounts[mainGroupId] =
        (oldGroupCounts[mainGroupId] || 0) + 1;
    });


    /*
     * ---------------------------------------------------------
     * GROUP NEW HEADS
     * ---------------------------------------------------------
     */

    const newGroupCounts = {};

    newScopes.forEach((item) => {

      const mainGroupId =
        item.selectedMainGroupId ||
        item.mainGroupId;

      newGroupCounts[mainGroupId] =
        (newGroupCounts[mainGroupId] || 0) + 1;
    });


    /*
     * ---------------------------------------------------------
     * CALCULATE EACH MAIN GROUP SEPARATELY
     * ---------------------------------------------------------
     */

    Object.keys(newGroupCounts).forEach(
      (mainGroupId) => {

        const oldCount =
          oldGroupCounts[mainGroupId] || 0;

        const newCount =
          newGroupCounts[mainGroupId] || 0;

        const totalCount =
          oldCount + newCount;


        /*
         * -------------------------------------------------
         * CASE 1
         * COMPLETELY NEW MAIN GROUP
         *
         * 1 head = base
         * 2 heads = base
         * 3 heads = base + 1 additional
         * 4 heads = base + 2 additional
         * -------------------------------------------------
         */

        if (oldCount === 0) {

          if (newCount <= 2) {

            pricingData[0].quantity += 1;

            pricingData[0].Amount +=
              max2GroupPrice;

          }
          else {

            const additionalCount =
              newCount - 2;


            pricingData[0].quantity += 1;

            pricingData[0].Amount +=
              max2GroupPrice;


            pricingData[1].quantity +=
              additionalCount;

            pricingData[1].Amount +=
              additionalGroupPrice *
              additionalCount;
          }
        }


        /*
         * -------------------------------------------------
         * CASE 2
         * EXISTING MAIN GROUP
         *
         * Existing 2 + New 1 = +50
         * Existing 2 + New 2 = +100
         *
         * Existing 3 + New 1 = +50
         *
         * -------------------------------------------------
         */

        else {

          const oldChargeableCount =
            Math.max(
              0,
              oldCount - 2
            );

          const totalChargeableCount =
            Math.max(
              0,
              totalCount - 2
            );

          const additionalCount =
            totalChargeableCount -
            oldChargeableCount;


          if (additionalCount > 0) {

            pricingData[1].quantity +=
              additionalCount;

            pricingData[1].Amount +=
              additionalGroupPrice *
              additionalCount;
          }
        }
      }
    );


    /*
     * ---------------------------------------------------------
     * SUBTOTAL
     * ---------------------------------------------------------
     */

    pricingData[2].quantity =
      pricingData[0].quantity +
      pricingData[1].quantity;

    pricingData[2].Amount =
      pricingData[0].Amount +
      pricingData[1].Amount;


    /*
     * ---------------------------------------------------------
     * UPDATE STATE
     * ---------------------------------------------------------
     */

    this.setState({
      priceCalculatorArrayTopUpAdditional:
        pricingData
    });


    /*
     * IMPORTANT:
     * Return pricingData so caller can immediately use
     * calculated amount without waiting for setState.
     */

    return pricingData;
  };
  getMembershipPricingWithGst = () => {
    this.slotMemberService.getMembershipPricingWithGst().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({
          slotsMemberPricingDetail: response.responseItem.responseContent,
        });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  removeSLOTSAuthoriseRepresentativeSummary = (
    slotsAuthoriseRepresentativeId
  ) => {
    if (this.state.slotsMemberId > 0) {
      let request = {};
      request.slotsAuthoriseRepresentativeId = slotsAuthoriseRepresentativeId;
      request.sLOTSMemberId = this.state.slotsMemberId;


      this.slotMemberService
        .removeSLOTSAuthoriseRepresentativeSummary(request)
        .then((response) => {
          if (response != null && response.statusCode === 200) {
            this.swalServices.Success(
              "Authorised representative summary deleted sucessfully!"
            );
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };

  BuyAdditionalRegistrationHeadTopUp = (event, priceCalculatorTopUp) => {
    if (this.state.slotsMemberId > 0) {

      let request = {};
      request.priceCalculator = priceCalculatorTopUp;
      request.isRenewal = this.state.SLOTSApplicationDetails.isRenewal;
      request.slotsMemberId = this.state.slotsMemberId;
      this.setState({ isLoading: true });
      if (request.priceCalculator && request.priceCalculator[2].Amount > 0) {
        this.slotMemberService
          .BuyAdditionalRegistrationHeadTopUp(request)
          .then((response) => {
            if (response != null && response.statusCode === 200) {
              this.swalServices.Success("Topup Additional Registration Head(s) added successfully");
              this.setState({ isLoading: false });
            } else {
              this.swalServices.Error(response.message);
              this.setState({ isLoading: false });
            }
          });
      }
    }
  };

  updateBasicAppicationDetails = () => {
    const audit = getAuditContext();

    if (this.state.slotsMemberId > 0) {

        this.setState({
            isBasicApplicationLoading: true
        });

        let res = {};

        res.slotsMemberId = this.state.slotsMemberId;
        res.companyName = this.state.SLOTSApplicationDetails.companyName;
        res.chineseCompanyName = this.state.SLOTSApplicationDetails.chineseCompanyName;
        res.uenNumber = this.state.SLOTSApplicationDetails.uenNumber;
        res.dateOfIncorporation = this.state.SLOTSApplicationDetails.dateOfIncorporation;
        res.mailingAddress1 = this.state.SLOTSApplicationDetails.mailingAddress1;
        res.mailingAddress2 = this.state.SLOTSApplicationDetails.mailingAddress2;
        res.mailingAddress3 = this.state.SLOTSApplicationDetails.mailingAddress3;
        res.buildingAddress = this.state.SLOTSApplicationDetails.buildingAddress;
        res.countryId = this.state.SLOTSApplicationDetails.countryId;
        res.postalCode = this.state.SLOTSApplicationDetails.postalCode;
        res.businessTelNo = this.state.SLOTSApplicationDetails.businessTelNo;
        res.businessEmail = this.state.SLOTSApplicationDetails.businessEmail;
        res.updatedBy = audit.adminUserId;
        res.updatedAppId = audit.appId;

        this.slotMemberService
            .updateBasicAppicationDetails(res)
            .then((response) => {

                console.log(
                    "Update Basic Application Response:",
                    response
                );

                const result =
                    response?.responseItem?.responseContent;

                /*
                 * UEN already exists
                 * Do NOT update and do NOT show success message.
                 */
                if (result?.hasError === true) {

                    this.setState({
                        isBasicApplicationLoading: false
                    });

                    this.swalServices.Error(
                        result.errorMessage ||
                        "The same UEN is already present."
                    );

                    return;
                }

                /*
                 * Successful update
                 */
                if (
                    response != null &&
                    response.statusCode === 200
                ) {

                    this.setState({
                        isBasicApplicationLoading: false
                    });

                    this.swalServices.Success(
                        "SLOTS basic application details saved successfully."
                    );

                    return;
                }

                /*
                 * API failure
                 */
                this.setState({
                    isBasicApplicationLoading: false
                });

                this.swalServices.Error(
                    response?.message ||
                    "Unable to update basic application details."
                );
            })
            .catch((error) => {

                console.log(
                    "Update Basic Application Error:",
                    error
                );

                this.setState({
                    isBasicApplicationLoading: false
                });

                this.swalServices.Error(
                    "Unable to update basic application details."
                );
            });
    }
};

  updateOrganisationProfileDetails = () => {
    const audit = getAuditContext();

    if (this.state.slotsMemberId > 0) {
      let res = {
        slotsMemberId: this.state.slotsMemberId,
        annualTurnOverId: this.state.SLOTSApplicationDetails.annualTurnOverId,
        companyDescription: this.state.SLOTSApplicationDetails.companyDescription,
        numberOfStaffEmployedLocalId: this.state.SLOTSApplicationDetails.numberOfStaffEmployedLocalId,
        foreignWorkPermitHolderId: this.state.SLOTSApplicationDetails.foreignWorkPermitHolderId,
        companyTypeId: this.state.SLOTSApplicationDetails.companyTypeId,
        projectTypeId: this.state.SLOTSApplicationDetails.projectTypeId,
        headOfCompanyFirstName: this.state.SLOTSApplicationDetails.headOfCompanyFirstName,
        headOfCompanyLastName: this.state.SLOTSApplicationDetails.headOfCompanyLastName,
        jobTitle: this.state.SLOTSApplicationDetails.jobTitle,
        directOfficeNumber: this.state.SLOTSApplicationDetails.directOfficeNumber,
        mobileNumber: this.state.SLOTSApplicationDetails.mobileNumber,
        email: this.state.SLOTSApplicationDetails.email,
        paidUpCapital: this.state.SLOTSApplicationDetails.paidUpCapital,
        updatedBy: audit.adminUserId,
        updatedAppId: audit.appId,
      };

      this.setState({ isOrganisationProfileLoading: true }, () => {
        const directorsList = Array.isArray(this.state.directors)
          ? this.state.directors.map((person) => ({
            ...person,
            isDirector: true,
            isShareholder: false,
            dateofAppoitment: person.dateofAppoitment // <-- ensure this exists
          }))
          : [];

        const shareholdersList = Array.isArray(this.state.shareholders)
          ? this.state.shareholders.map((person) => ({
            ...person,
            isDirector: false,
            isShareholder: true,
            percentageOfshare: person.percentageOfshare // <-- ensure this exists
          }))
          : [];


        // 👇 Merge director + shareholder list into the res object before sending
        res.directorAndShareHolderList = [...directorsList, ...shareholdersList];
        //res.specifyOtherCompanyType = this.state.SLOTSApplicationDetails.specifyOtherCompanyType;
        // 🔁 Send full updated data
        this.slotMemberService
          .updateOrganisationProfileDetails(res)
          .then((response) => {
            if (response != null && response.statusCode === 200) {

              this.swalServices.Success("SLOTS Organisation Profile details updated successfully.");
              this.setState({ isOrganisationProfileLoading: false });
            } else {
              this.swalServices.Error(response.message);
              this.setState({ isOrganisationProfileLoading: false });
            }
          });
      });
    }
  };

  updateForceRenewalFlag = () => {

    if (this.state.slotsMemberId > 0) {
      let data = this.state.SLOTSApplicationDetails;
      let request = [this.state.slotsMemberId, !data.isForceRenewal]
      this.setState({ isForceRenewalLoader: true });

      this.slotMemberService
        .updateForceRenewalFlag(request)
        .then((response) => {
          if (response != null && response.statusCode === 200) {

            data.isForceRenewal = !data.isForceRenewal;
            if (data.isForceRenewal) {
              this.swalServices.Success("Force renewal functionality activated sucessfully.");
            } else {
              this.swalServices.Success("Force renewal functionality deactivated sucessfully.");
            }
            this.setState({ isForceRenewalLoader: false, SLOTSApplicationDetails: data });
          } else {
            this.swalServices.Error(response.message);
            this.setState({ isForceRenewalLoader: false });
          }
        });
    }
  }
  handleChangeFordirectors = (updatedDirectors) => {
    this.setState({ directors: updatedDirectors });
  };
  handleChangeForsetshareholders = (updatedshareholders) => {
    this.setState({ shareholders: updatedshareholders });
  };
  getProjectTrackrecordsDetailById = (id, id1, isOnGoing, isDeleted) => {
    if (id > 0 || id1 > 0) {
      let request = {
        id: id === 0 || id === null ? id1 : id,
        isOnGoing,
        isDeleted
      }
      this.setState({ isLoading: true });
      this.slotMemberService.getProjectTrackRecordsDetailById(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (isDeleted === true) {
            this.swalServices.Deleted("Record Deleted...");
            this.GetAllProjectTrackRecordsById(this.state.slotsMemberId);
            this.setState({ isLoading: false });
          }
          const data = response.responseItem.responseContent;

          data.letterofAwardorPurchaseOrderList = data.letterofAwardorPurchaseOrderDocs
            ? data.letterofAwardorPurchaseOrderDocs.split(',')
            : [];


          data.certificateofcompletionList = data.certificateOfCompletionPath
            ? data.certificateOfCompletionPath.split(',')
            : [];

          data.finalInvoiceFilePathList = data.finalInvoiceFilePath
            ? data.finalInvoiceFilePath.split(',')
            : [];
          this.setState({
            certificateofcompletionCount: data.certificateofcompletionList.length,
            finalInvoiceFileCount: data.finalInvoiceFilePathList.length,
            LetterofAwardorPurchaseCount: data.letterofAwardorPurchaseOrderList.length
          })
          this.setState({ projectTrackRecordsDetails: data });
          this.setState({ letterofAwardorPurchaseOrderList: data.letterofAwardorPurchaseOrderList });
          this.setState({ certificateofcompletionList: data.certificateofcompletionList });
          this.setState({ finalInvoiceFilePathList: data.finalInvoiceFilePathList });

          console.log("response.responseItem.responseContent ", this.state.projectTrackRecordsDetails)
        }
        this.setState({ isLoading: false });
      })
    }
  }
  validateField = (key, section) => {
    if (section === "SLOTS_Application") {
      const newValidState = validate(
        key,
        this.state.SLOTSApplicationDetails,
        SLOTSApplicationValidationRules,
        this.state.validStateSLOTSMember
      );
      this.setState({ validStateSLOTSMember: newValidState });
    }
  }
  isValidateAllFields = (section) => {

    if (section === "Add_Project") {
      // or props, wherever you're tracking them
      let isOnGoing = this.state.projectTrackRecordsDetails.isOngoing;
      let isCompleted = this.state.projectTrackRecordsDetails.isCompleted;
      let projectTypeId = this.state.projectTrackRecordsDetails.projectType;
      let data = this.state.projectTrackRecordsDetails;
      data.projectType = projectTypeId;
      this.setState({ projectTrackRecordsDetails: data });
      let detail = this.state.projectTrackRecordsDetails;

      // Clone and filter the validation rules
      const filteredRules = { ...ProjectTrackRecordValidationRules };

      if (isOnGoing && !isCompleted) {
        delete filteredRules.actualDateOfCompletion;
        delete filteredRules.CertificateOfCompletionPath;
        delete filteredRules.FinalInvoiceFilePathCompleted;
        if (detail.finalInvoiceFilePathList && detail.finalInvoiceFilePathList.length > 0) {
          delete filteredRules.FinalInvoiceFilePath;
        }
      } else if (isCompleted && !isOnGoing) {
        delete filteredRules.dateofCompletion;
        delete filteredRules.FinalInvoiceFilePath;
        if ((detail.certificateOfCompletionPath && detail.certificateOfCompletionPath != null) || detail.certificateofcompletionList.length > 0) {
          delete filteredRules.CertificateOfCompletionPath;
        }
        if (detail.finalInvoiceFilePathList && detail.finalInvoiceFilePathList.length > 0) {
          delete filteredRules.FinalInvoiceFilePathCompleted;
        }
      }
      if (projectTypeId === 1) {
        delete filteredRules.agency;
      }
      if (detail.letterofAwardorPurchaseOrderList && detail.letterofAwardorPurchaseOrderList.length > 0) {
        delete filteredRules.LetterofAwardorPurchase;
      }

      const newValidState = isValidForm(
        this.state.projectTrackRecordsDetails,
        filteredRules,
        this.state.validStateProjectTrackRecord
      );

      this.setState({ validStateProjectTrackRecord: newValidState });
      return newValidState.isValid;
    }
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="main-body-section">
          <div className="custom-card shadow-lg bg-white">
            {/* <h2>{this.state.slotsMemberId}</h2> */}
            <div>
              {this.state.SLOTSApplicationDetails && this.state.SLOTSApplicationDetails.isExpiredMember === true ?
                <div className="flex justify-end">
                  <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                    <div className="check-box-sec flex items-center register-desc mb-5">
                      <div className={''}>
                        <CheckboxInput
                          id="isForceRenewal"
                          name="isForceRenewal"
                          className="cursor-pointer text-[#e1e1e1] focus:ring-[#e1e1e1] rounded check-box-custom"
                          checked={this.state.SLOTSApplicationDetails.isForceRenewal}
                          //value={props.SLOTSApplicationDetails.isForceRenewal}
                          handleChange={this.updateForceRenewalFlag.bind()}
                        //disabled={props.isDisabledFlag ? true : false}
                        />
                      </div>
                      {this.state.isForceRenewalLoader && this.state.isForceRenewalLoader === true ?
                        <>
                          <span className="filter-lable font-bold text-[#757575] pl-4">
                            Loading...
                          </span>
                        </>
                        :
                        <>
                          <span className="filter-lable font-bold text-[#757575] pl-4">
                            Force Renewal
                          </span>
                        </>
                      }
                    </div>
                    {/* <ValidationText error={props.validStateSLOTSMember.error.companyName} /> */}
                  </div>
                </div>
                :
                null
              }
              <div className="basic-application">
                <SectionWithBorder
                  totalColumn={1}
                  textSize="2xl"
                  className="font-bold pr-0"
                  column1={
                    <>
                      <div className="flex items-center justify-between">
                        <div className=" text-[25px] text-[#000000]">
                          <p>Basic Application</p>
                        </div>
                        <div className="flex gap-x-[25px] justify-end">
                          {this.state.SLOTSApplicationDetails.IsMigratedData ?
                            <>
                              <div>
                                {this.state.SLOTSApplicationDetails.IsMigratedData && "Is Migrated"}
                              </div>
                            </>
                            :
                            null
                          }
                          {this.state.SLOTSApplicationDetails.IsMigratedData && this.state.SLOTSApplicationDetails.CertificateMembershipNo ?
                            <>
                              |
                            </>
                            :
                            null
                          }
                          {this.state.SLOTSApplicationDetails.CertificateMembershipNo ?
                            <>
                              <div>
                                <p>{this.state.SLOTSApplicationDetails.CertificateMembershipNo}</p>
                              </div>
                            </>
                            :
                            null
                          }

                        </div>
                      </div>


                      {/* <div className="flex items-left justify-between text-[25px] text-[#000000]">
                      <p>Basic Application</p>
                      <p>{this.state.SLOTSApplicationDetails.IsMigratedData ? "Is Migrated" : null } </p>
                      {this.state.SLOTSApplicationDetails.CertificateMembershipNo && (
                        <p>{this.state.SLOTSApplicationDetails.CertificateMembershipNo}</p>
                      )}
                    </div> */}
                    </>
                  }
                >

                  <BasicAppication
                    countryList={this.state.countryList}
                    SLOTSApplicationDetails={this.state.SLOTSApplicationDetails}
                    // validStateBasicApplication={this.state.validStateBasicApplication}
                    isDisabledFlag={this.state.isDisabledFlag}
                    isExpiredMember={this.state.isExpiredMember}
                    handleChange={this.handleChange.bind(this)}
                    handleChangeInDropdown={this.handleChangeInDropdown.bind(
                      this
                    )}
                    // validateField={this.validateSLOTSMember.bind(this)}
                    updateBasicAppicationDetails={this.updateBasicAppicationDetails.bind(this)}
                    isBasicApplicationLoading={this.state.isBasicApplicationLoading}
                    isForceRenewalLoader={this.state.isForceRenewalLoader}
                    updateForceRenewalFlag={this.updateForceRenewalFlag.bind(this)}
                  />
                </SectionWithBorder>
              </div>

            </div>

            <div>
              <SectionWithBorder
                totalColumn={1}
                textSize="2xl"
                className="font-bold"
                column1="Organisation Profile"
              >
                <OrganisationProfile
                  annualTurnoverList={this.state.annualTurnoverList}
                  staffEmployeeLocalList={this.state.staffEmployeeLocalList}
                  roleList={this.state.roleList}
                  SLOTSApplicationDetails={this.state.SLOTSApplicationDetails}
                  roleDetails={this.state.roleDetails}
                  validStateOrganisationProfile={this.state.validStateOrganisationProfile}
                  validStateSLOTSMemberRole={
                    this.state.validStateSLOTSMemberRole
                  }
                  isDisabledFlag={this.state.isDisabledFlag}
                  isACRACerLoader={this.state.isACRACerLoader}
                  isWPRecordLoader={this.state.isWPRecordLoader}
                  is6MonCPFLoader={this.state.is6MonCPFLoader}
                  isCPFConLoader={this.state.isCPFConLoader}
                  isApprovedBCALoader={this.state.isApprovedBCALoader}
                  isOrganisationProfileLoading={this.state.isOrganisationProfileLoading}
                  handleChange={this.handleChange.bind(this)}
                  handleChangeInDropdown={this.handleChangeInDropdown.bind(
                    this
                  )}
                  validateField={this.validateSLOTSMember.bind(this)}
                  validateRole={this.validateSLOTSMemberRole.bind(this)}
                  GetSlotsMemberFiles={this.GetSlotsMemberFiles.bind(this)}
                  foreignWorkPermitHolderList={
                    this.state.foreignWorkPermitHolderList
                  }
                  RegisteredCompanyTypesList={this.state.RegisteredCompanyTypesList}
                  SlotProjectTypeList={this.state.SlotProjectTypeList}
                  DownloadMultipleFilesZip={this.DownloadMultipleFilesZip.bind(
                    this
                  )}
                  onFileChange={this.onFileChange.bind(this)}
                  deleteFile={this.deleteFile.bind(this)}
                  updateOrganisationProfileDetails={this.updateOrganisationProfileDetails.bind(this)}
                  getAuthorisedRepresentative={this.getAuthorisedRepresentative.bind(this)}
                  directors={this.state.directors}
                  shareholders={this.state.shareholders}

                  setDirectors={this.handleChangeFordirectors}
                  setShareholders={this.handleChangeForsetshareholders}

                  projectDevelopmentTypesList={this.state.directorsTypesList}
                  swalAlert={this.swalServices}
                  onSave={this.updateOrganisationProfileDetails.bind(this)}
                  slotsMemberId={this.state.slotsMemberId}
                  validState={this.state.validStateOrganisationProfile}
                />
              </SectionWithBorder>
            </div>

            <div>
              <SectionWithBorder
                totalColumn={1}
                textSize="2xl"
                className="font-bold"
                column1="SLOTS Application"
              >
                <SLOTSApplication
                  resetAllProjectTractRecordsFields={this.resetAllProjectTractRecordsFields.bind(this)}
                  getProjectTrackRecordDataToEdit={this.getProjectTrackRecordDataToEdit.bind(this)}
                  ongoingProjectTrackRecordsDetailsList={this.state.ongoingProjectTrackRecordsDetailsList}
                  completedProjectTrackRecordsDetailsList={this.state.completedProjectTrackRecordsDetailsList}
                  projectTrackRecordsDetailsList={this.state.projectTrackRecordsDetailsList}
                  isOngoing={this.state.IsOngoing}
                  isCompleted={this.state.IsCompleted}
                  setProjectTypeFlags={this.setProjectTypeFlags.bind(this)}
                  handleChangeForProjectTractRecords={this.handleChangeForProjectTractRecords.bind(this)}
                  countryList={this.state.countryList}
                  handleRadioClick={this.handleRadioClick}
                  mainGroupList={this.state.mainGroupList}
                  workheadList={this.state.workheadList}
                  gradeList={this.state.gradeList}
                  validStateSLOTSMember={this.state.validStateSLOTSMember}
                  SLOTSApplicationDetails={this.state.SLOTSApplicationDetails}
                  auditCertificateDetailes={this.state.auditCertificateDetailes}

                  selectedBuildingConScope={this.state.selectedBuildingConScope}
                  selectedSLOTSRegistrationScope={
                    this.state.selectedSLOTSRegistrationScope
                  }
                  projectTrackRecordsDetails={this.state.projectTrackRecordsDetails}

                  mainGroupListPricing={this.state.mainGroupListPricing}
                  workheadListPricing={this.state.workheadListPricing}
                  priceCalculatorArray={this.state.priceCalculatorArray}
                  validStateBCAScope={this.state.validStateBCAScope}
                  validStateregistrationScope={
                    this.state.validStateregistrationScope
                  }
                  isDisabledFlag={this.state.isDisabledFlag}
                  isBankAccStatLoader={this.state.isBankAccStatLoader}
                  isOnGoingProLoader={this.state.isOnGoingProLoader}
                  isOnGoingProLoader2={this.state.isOnGoingProLoader2}
                  isCompProLoader={this.state.isCompProLoader}
                  isCompProLoader2={this.state.isCompProLoader2}
                  isFormALoader={this.state.isFormALoader}
                  isFormASupportingDocumentLoader={this.state.isFormASupportingDocumentLoader}
                  isPaymentProofLoader={this.state.isPaymentProofLoader}

                  // renewalSLOTSRegistrationHeadScope={this.state.renewalSLOTSRegistrationHeadScope}
                  handleChange={this.handleChange.bind(this)}
                  handleChangeInDropdown={this.handleChangeInDropdown.bind(
                    this
                  )}
                  GetSlotsMemberFiles={this.GetSlotsMemberFiles.bind(this)}
                  renewalDataLength={this.state.renewalDataLength}
                  DownloadMultipleFilesZip={this.DownloadMultipleFilesZip.bind(
                    this
                  )}
                  onFileChange={this.onFileChange.bind(this)}
                  deleteFile={this.deleteFile.bind(this)}
                  deleteSlotsMembersFilesComman={this.deleteSlotsMembersFilesComman.bind(this)}
                  removeRegistrationHead={this.removeRegistrationHead.bind(
                    this
                  )}
                  removeRegistrationHeadAdditional={this.removeRegistrationHeadAdditional.bind(
                    this
                  )}
                  pricingCalculation={this.pricingCalculation.bind()}
                  pricingCalculationAdditional={this.pricingCalculationAdditional.bind()}
                  currentPriceCalculatorArray={this.state.priceCalculatorArray}
                  priceCalculatorArrayTopUpAdditional={this.state.priceCalculatorArrayTopUpAdditional}
                  handleAddRolesAndScope={this.handleAddRolesAndScope.bind(
                    this
                  )}
                  handleRemoveRolesAndScope={this.handleRemoveRolesAndScope.bind(
                    this
                  )}
                  BuyAdditionalRegistrationHeadTopUp={this.BuyAdditionalRegistrationHeadTopUp.bind(
                    this
                  )}
                  getSLOTSMemberDetailByMemberId={this.getSLOTSMemberDetailByMemberId.bind(this)}
                  updateSLOTSRegistrationHeadScopeTopUp={this.updateSLOTSRegistrationHeadScopeTopUp.bind(this)}
                  //saveInformtion={this.saveInformtion.bind(this)}
                  auditCertificate={this.state.SLOTSApplicationDetails.auditCertificateDetailes}
                  isRegisteringasSlots={this.state.isRegisteringasSlots}
                  isConfirmedCRS={this.state.isConfirmedCRS}
                  projectTypelist={this.state.SlotProjectTypeList}
                  AddEditProjectTrackRecord={this.AddEditProjectTrackRecord.bind(this)}
                  letterofAwardorPurchaseOrderList={this.state.letterofAwardorPurchaseOrderList}
                  certificateofcompletionList={this.state.certificateofcompletionList}
                  finalInvoiceFilePathList={this.state.finalInvoiceFilePathList}
                  getProjectTrackrecordsDetailById={this.getProjectTrackrecordsDetailById.bind(this)}
                  validateField={this.validateField.bind(this)}
                  validStateProjectTrackRecord={this.state.validStateProjectTrackRecord}
                  IsProbationaryAtStart={this.state.IsProbationaryAtStart}
                  isLoading={this.state.isLoading}
                />
              </SectionWithBorder>
            </div>
            {(this.state.SLOTSApplicationDetails.statusId === 17 ||
              this.state.SLOTSApplicationDetails.statusId === 18) &&
              this.state.SLOTSApplicationDetails.statusId !== 21 ? (
              <>
                <div>
                  <SectionWithBorder
                    totalColumn={1}
                    textSize="2xl"
                    className="font-bold"
                    column1="Annual fee payment details"
                  >

                    <>
                      <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-2 2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
                        {/* SLOTs Registration Head(s) Selection Section */}
                        {/* SLOTs Registration Head Table Section */}
                        <div className="col-span-12">
                          <div className="table-section">
                            <div className="overflow-x-auto">
                              <table className="w-full">
                                <thead className="bg-[#e78e3c] text-white">
                                  <tr>
                                    <th className="whitespace-nowrap text-left py-3 px-5">Selected Scope</th>
                                    <th className="whitespace-nowrap text-left py-3 px-5">Workhead</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.SLOTSApplicationDetails?.slotsRegistrationHeadScope?.map((scope, key) => (
                                    <tr className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]" key={key}>
                                      <td className="whitespace-nowrap text-left py-2 px-5">{scope.mainGroupName}</td>
                                      <td className="whitespace-nowrap text-left py-2 px-5">{scope.workheadName}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>


                        <div className="col-span-12 mt-5">
                          <div className="grid grid-cols-12 gap-4 w-full justify-between">
                            <div className="lg:col-span-6 col-span-12">
                              <h2 className="input-title">
                                Price Calculator
                                <span className="text-[#C00000]">*</span>
                              </h2>
                            </div>
                            <div className="col-span-12">
                              <div className="table-section">
                                <div className="overflow-x-auto">
                                  <table className="w-full">
                                    <thead className="bg-[#e78e3c] text-white">
                                      <tr>
                                        <th className="whitespace-nowrap text-left py-3 px-5">
                                          Description
                                        </th>
                                        <th className="whitespace-nowrap text-left py-3 px-5">
                                          Quantity
                                        </th>
                                        <th className="whitespace-nowrap text-center py-3 px-5">
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.SLOTSApplicationDetails?.priceCalculator.map(
                                        (price, key) => {
                                          return (
                                            <tr
                                              className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]"
                                              key={key}
                                            >
                                              <td className="whitespace-nowrap text-left py-2 px-5">
                                                {price.description}
                                              </td>
                                              <td className="whitespace-nowrap text-left py-2 px-5">
                                                {price.quantity}
                                              </td>
                                              <td className="whitespace-nowrap text-center py-2 px-5">
                                                ${price.amount}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-12 mt-0">
                          <div className="flex justify-end">
                            {this.state.isPaymentLinkLoader ? (
                              <ButtonLoader className="w-[250px] p-3 mt-4 btn btn-orange-border mr-5" />
                            ) : (
                              <>

                                <button
                                  className={`col-start-1 col-end-3 text-xl font-bold btn btn-orange-border w-[250px] text-red p-3 mt-4 mr-5 ${this.state.isDisabledFlag
                                    ? "cursor-not-allowed"
                                    : null
                                    }`}
                                  onClick={() => {
                                    this.sendPaymentLinkOfSLOTSMember();
                                  }}
                                  disabled={
                                    this.state.isDisabledFlag ? true : false
                                  }
                                >
                                  Send Payment Link
                                </button>


                                {/* <button
                              className={`col-start-1 col-end-3 text-xl font-bold btn btn-orange-border w-[250px] text-red p-3 mt-4 mr-5 ${this.state.isDisabledFlag
                                ? "cursor-not-allowed"
                                : null
                                }`}
                              onClick={() => {
                                this.sendPaymentLinkOfSLOTSMember();
                              }}
                              disabled={
                                this.state.isDisabledFlag ? true : false
                              }
                            >
                              Send Payment link
                            </button> */}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  </SectionWithBorder>
                </div>
              </>
            ) : null}
            {this.state.SLOTSApplicationDetails.statusId === 22 ?
              <>
                <div>
                  <SectionWithBorder
                    totalColumn={1}
                    textSize="2xl"
                    className="font-bold"
                    column1="Renewal fee payment details"
                  >
                    <RenewalScopeHeadDetails
                      isRenewal={true}
                      /* ---------- Flags ---------- */
                      isDisabledFlag={this.state.isDisabledFlag}

                      /* ---------- Application Details ---------- */
                      SLOTSApplicationDetails={this.state.SLOTSApplicationDetails}

                      /* ---------- Pricing Lists ---------- */
                      mainGroupListPricing={this.state.mainGroupListPricing}
                      workheadListPricing={this.state.workheadListPricing}

                      /* ---------- Scope & Validation ---------- */
                      selectedSLOTSRegistrationScope={this.state.selectedSLOTSRegistrationScope}
                      validStateregistrationScope={this.state.validStateregistrationScope}

                      /* ---------- Pricing Calculations ---------- */
                      priceCalculatorArray={this.state.priceCalculatorArray}
                      priceCalculatorArrayTopUpAdditional={
                        this.state.priceCalculatorArrayTopUpAdditional
                      }

                      /* ---------- Handlers ---------- */
                      pricingCalculation={this.pricingCalculation.bind(this)}
                      pricingCalculationAdditional={this.pricingCalculationAdditional.bind(this)}

                      handleChange={this.handleChange.bind(this)}
                      handleChangeInDropdown={this.handleChangeInDropdown.bind(this)}

                      removeRegistrationHead={this.removeRegistrationHead.bind(this)}
                      removeRegistrationHeadAdditional={this.removeRegistrationHeadAdditional.bind(this)}

                      BuyAdditionalRegistrationHeadTopUp={
                        this.BuyAdditionalRegistrationHeadTopUp.bind(this)
                      }

                      getSLOTSMemberDetailByMemberId={
                        this.getSLOTSMemberDetailByMemberId.bind(this)
                      }
                      addSLOTSRenewalRegistrationHeadScope={
                        this.AddSLOTSRenewalRegistrationHeadScope
                      }
                      removeRenewalRegistrationHead={this.removeRenewalRegistrationHead.bind(this)}
                    />
                    <>
                      <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-2 2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
                        {/* SLOTs Registration Head(s) Selection Section */}
                        {/* SLOTs Registration Head Table Section */}
                        <div className="col-span-12">
                          <div className="table-section">
                            <div className="overflow-x-auto">
                              <table className="w-full">
                                <thead className="bg-[#e78e3c] text-white">
                                  <tr>
                                    <th className="whitespace-nowrap text-left py-3 px-5">Selected Scope</th>
                                    <th className="whitespace-nowrap text-left py-3 px-5">Workhead</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.SLOTSApplicationDetails?.renewalSLOTSRegistrationHeadScope?.map((scope, key) => (
                                    <tr className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]" key={key}>
                                      <td className="whitespace-nowrap text-left py-2 px-5">{scope.mainGroupName}</td>
                                      <td className="whitespace-nowrap text-left py-2 px-5">{scope.workheadName}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-span-12 mt-5">
                          <div className="grid grid-cols-12 gap-4 w-full justify-between">
                            <div className="lg:col-span-6 col-span-12">
                              <h2 className="input-title">
                                Price Calculator
                                <span className="text-[#C00000]">*</span>
                              </h2>
                            </div>
                            <div className="col-span-12">
                              <div className="table-section">
                                <div className="overflow-x-auto">
                                  <table className="w-full">
                                    <thead className="bg-[#e78e3c] text-white">
                                      <tr>
                                        <th className="whitespace-nowrap text-left py-3 px-5">
                                          Description
                                        </th>
                                        <th className="whitespace-nowrap text-left py-3 px-5">
                                          Quantity
                                        </th>
                                        <th className="whitespace-nowrap text-center py-3 px-5">
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.SLOTSApplicationDetails?.renewalPriceCalculator.map(
                                        (price, key) => {
                                          return (
                                            <tr
                                              className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]"
                                              key={key}
                                            >
                                              <td className="whitespace-nowrap text-left py-2 px-5">
                                                {price.description}
                                              </td>
                                              <td className="whitespace-nowrap text-left py-2 px-5">
                                                {price.quantity}
                                              </td>
                                              <td className="whitespace-nowrap text-center py-2 px-5">
                                                ${price.Amount}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-span-12 mt-0">
                          <div className="flex justify-end">
                            {this.state.isPaymentLinkLoader ? (
                              <ButtonLoader className="w-[250px] p-3 mt-4 btn btn-orange-border mr-5" />
                            ) : (
                              <>
                                <button
                                  className={`col-start-1 col-end-3 text-xl font-bold btn btn-orange-border text-red p-3 mt-4 mr-5`}
                                  onClick={() => {
                                    this.acceptRenewSLOTSMembership();
                                  }}
                                >
                                  Send Payment Link For Renewal
                                </button>
                                {/* <button
                                    className={`col-start-1 col-end-3 text-xl font-bold btn btn-orange-border w-[250px] text-red p-3 mt-4 mr-5`}
                                    onClick={() => {
                                      this.acceptRenewSLOTSMembership();
                                    }}          
                                  >
                                  Send Payment link for renewal
                                </button> */}
                              </>
                            )}
                          </div>
                        </div>
                      </div>


                    </>
                  </SectionWithBorder>
                </div>
              </>
              :
              null
            }
            <div className="2xl:col-span-12 lg:col-span-12 col-span-12 px-8">
              <div className="flex items-center justify-end">
                <div className="flex gap-3 items-center justify-between mt-3">
                  {this.state.SLOTSApplicationDetails.statusId === 22 ?
                    null
                    : <>
                      {
                        this.state.SLOTSApplicationDetails.statusId !== 21 ? (
                          this.state.isLoadingExpireApplication ? (
                            <ButtonLoader className="w-[250px] p-3 mt-4 btn btn-orange" />
                          ) : (
                            <button
                              className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange w-[250px] p-3 mt-4 ${this.state.isDisabledFlag ? 'cursor-not-allowed' : null}`}
                              onClick={() => this.ExpireSlotsMemberApplication()}
                              disabled={this.state.isDisabledFlag ? true : false}
                            >
                              Expire Application
                            </button>
                          )
                        ) : null
                      }</>
                  }

                  {this.state.SLOTSApplicationDetails.statusId !== 21 ? (
                    <button
                      className={`col-start-1 col-end-3 text-xl font-bold btn btn-orange-border w-[250px] text-red p-3 mt-4 ${this.state.isDisabledFlag ? "cursor-not-allowed" : null
                        }`}
                      onClick={this.setSendClarificationsFlag.bind(this)}
                      disabled={this.state.isDisabledFlag ? true : false}
                    >
                      Send Clarifications
                    </button>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="2xl:col-span-12 lg:col-span-12 col-span-12 px-8">
              <div className="flex items-center justify-end">
                <div className="flex gap-3 items-center justify-between mt-3">
                  {this.state.SLOTSApplicationDetails.statusId === 12 &&
                    this.state.SLOTSApplicationDetails.statusId !== 21 ? (
                    this.state.isLoading ? (
                      <ButtonLoader className="w-[250px] p-3 mt-4 btn btn-orange" />
                    ) : (
                      <button
                        className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange w-[250px] p-3 mt-4 ${this.state.isDisabledFlag ? 'cursor-not-allowed' : null}`}
                        onClick={() => {
                          this.rejectSLOTSMemberApplication("UnReject");
                        }}
                        disabled={this.state.isDisabledFlag ? true : false}
                      >
                        Appeal Process
                      </button>
                    )
                  ) : (
                    <>
                      {this.state.SLOTSApplicationDetails.statusId ===
                        4 ? null : (this.state.SLOTSApplicationDetails
                          .statusId === 15 ||
                          this.state.SLOTSApplicationDetails.statusId === 16) &&
                          this.state.SLOTSApplicationDetails.statusId !== 21 ? (
                        this.state.isWorkshopProofLoader ? (
                          <ButtonLoader className="w-[250px] mt-4 btn btn-orange-border mr-5" />
                        ) : (
                          <>
                            <button
                              className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange-border text-red w-[250px] p-3 mt-4 ${this.state.isDisabledFlag
                                ? "cursor-not-allowed"
                                : null
                                } `}
                              onClick={() => {
                                this.sendReconciliationUploadWorkshopProofLinkToSlots(false);
                              }}
                              disabled={
                                this.state.isDisabledFlag ? true : false
                              }
                            >
                              Send Workshop Proof Link
                            </button>
                            {this.state.SLOTSApplicationDetails.statusId !== 22 && (
                              <button
                                className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange-border text-red w-[250px] p-3 mt-4 ${this.state.isDisabledFlag
                                  ? "cursor-not-allowed"
                                  : null
                                  } `}
                                onClick={() => {
                                  this.sendReconciliationUploadWorkshopProofLinkToSlots(true);
                                }}
                                disabled={
                                  this.state.isDisabledFlag ? true : false
                                }
                              >
                                Send Workshop Proof Link (Probationary)
                              </button>
                            )}
                          </>

                        )
                      ) : null}




                      {this.state.isLoading ? (
                        <ButtonLoader className="w-[250px] p-3 mt-4 btn btn-orange" />
                      ) : (
                        <button
                          className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange w-[250px] p-3 mt-4 ${this.state.isDisabledFlag
                            ? "cursor-not-allowed"
                            : null
                            }`}
                          onClick={() => {
                            this.editSlotsMemberDetails();
                          }}
                          disabled={this.state.isDisabledFlag ? true : false}
                        >
                          Update
                        </button>
                      )}



                      <button
                        className={`col-end-9 col-span-2 text-xl font-bold btn btn-orange w-[250px] p-3 mt-4 ${this.state.isDisabledFlag
                          ? "cursor-not-allowed"
                          : null
                          }`}
                        //onClick={() => { this.rejectSLOTSMemberApplication('Rejected'); }}
                        onClick={this.setSendRejectionReasonFlag.bind(this)}
                        disabled={this.state.isDisabledFlag ? true : false}
                      >
                        Reject application
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="membership-task-list-process-sec">
              <div className="send-clarification-model">
                <SendClarifications
                  validState={this.state.validState}
                  validateField={this.validateSLOTSMember.bind(this)}
                  clarificationModal={this.state.setSendClarifications}
                  clarification={this.state.clarification}
                  isLoading={this.state.isLoading}
                  setOpenModal={() =>
                    this.setState({ setSendClarifications: false })
                  }
                  onTinyEceEditorChange={(data) =>
                    this.handleChangeClarificationDetails(data)
                  }
                  // onClose={(e) => {e.stopPropagation();
                  //   this.setState({ setSendClarifications: false });
                  // }}
                  saveClarificationDetails={this.saveClarificationDetails.bind(
                    this
                  )}
                />
              </div>
            </div>
            <div className="membership-task-list-process-sec">
              <div className="send-clarification-model">
                <SendRejectionReason
                  rejectionModal={this.state.setRejectionReason}
                  sendRejectionReason={this.state.sendRejectionReason}
                  isLoadingRejectAplication={
                    this.state.isLoadingRejectAplication
                  }
                  setOpenModal={() =>
                    this.setState({ setRejectionReason: false })
                  }
                  onTinyEceEditorChange={(data) =>
                    this.handleChangeSendRejectionReasonDetails(data)
                  }
                  // handleChangeSendRejectionReasonDetails={this.handleChangeSendRejectionReasonDetails.bind(this)}
                  // onClose={(e) => {e.stopPropagation();
                  //   this.setState({ setRejectionReason: false });
                  // }}
                  btn_color={"btn-orange"}
                  rejectSLOTSMemberApplication={this.rejectSLOTSMemberApplication.bind(
                    this
                  )}
                />
              </div>
            </div>
          </div>
        </div >
      </>
    );
  }
}
